<template>
  <Toast />
  <ConfirmDialog />

  <div v-if="cargandoComponente">
    <div class="grid" v-if="permitirVenta">
      <div class="col-12 md:col-8">
        <div class="card">
          <div class="p-fluid formgrid grid p-fondo">
            <div class="field col-12 md:col-6 mt-2">
              <span><strong>BUSCAR CLIENTE | NOMBRE | CI/NIT:</strong></span>
              <div class="p-inputgroup">
                <AutoComplete
                  field="nombre"
                  v-model="clienteSelect"
                  :suggestions="clientes"
                  placeholder="Buscar Cliente (min 2 caracteres)"
                  v-tooltip.top="'Buscar por nombre, apellido, CI o código'"
                  @complete="buscarClienteAutoComplete($event)"
                  :loading="cargandoCliente"
                  :minLength="1"
                  autofocus
                >
                  <template #item="slotProps">
                    <div class="p-1 border-bottom-1 surface-border hover:surface-hover cursor-pointer">
                      <div style="font-size: 1.1rem; color: #2c3e50">
                        <span style="font-weight: 700">{{ slotProps.item.nombre }}</span>
                        <span v-if="slotProps.item.ci_nit" style="font-weight: 400; color: #2c3e50">
                          - Nit: {{ slotProps.item.ci_nit }}
                        </span>
                      </div>
                    </div>
                  </template>

                  <template #empty>
                    <div class="p-3 text-center">
                      <i class="pi pi-info-circle mb-2" style="font-size: 2rem; color: #64748b"></i>
                      <p class="mb-2">No se encontraron resultados</p>
                      <Button
                        v-if="'Cliente Crear' in auth.user.permissions"
                        label="Registrar Nuevo Paciente"
                        icon="pi pi-plus"
                        class="p-button-sm p-button-success"
                        @click="activarCliente"
                      />
                    </div>
                  </template>
                </AutoComplete>
                <Button
                  v-if="'Cliente Crear' in auth.user.permissions"
                  icon="pi pi-user-plus"
                  class="p-button-info"
                  v-tooltip.top="'Nuevo Paciente'"
                  @click="activarCliente"
                />
              </div>
              <div
                class="p-inputgroup mt-1"
                v-if="clienteSelect != null && clienteSelect.id != null && clienteSelect.tipo_cliente_id != 1"
              >
                <span>
                  <strong class="mr-1 text-900">TIPO CLIENTE:</strong>
                  <span class="p-tag p-tag-rounded p-tag-warning">
                    {{ clienteSelect.nombre_tipo_cliente ?? '' }}
                  </span>
                </span>
              </div>
            </div>
            <div class="field col-12 md:col-6 mt-2" v-if="facturar">
              <span><strong>CI/NIT:</strong></span>
              <div class="p-inputgroup">
                <AutoComplete
                  v-model="nitClienteSelect"
                  :suggestions="nitClientesFiltrados"
                  field="nombre"
                  placeholder="Buscar por NIT o Nombre"
                  v-tooltip.top="'Buscar Cliente por NIT o Nombre (mín 3 caracteres)'"
                  @keyup.enter="buscarClientePorNitConEnter"
                  @item-select="seleccionarClienteNit($event)"
                  :loading="cargandoNit"
                  :minLength="3"
                  :completeOnFocus="false"
                  :forceSelection="false"
                >
                  <template #item="slotProps">
                    <div class="flex align-items-center p-2">
                      <i class="pi pi-building mr-2" style="font-size: 1.3rem; color: #5dade2"></i>

                      <div class="flex-1">
                        <strong style="font-size: 1.1rem">{{ slotProps.item.nombre }}</strong>

                        <div class="text-sm text-secondary mt-1">
                          <span v-if="slotProps.item.tipo_documento === 5">
                            <strong>NIT:</strong>
                            <span class="nit-numero-destacado">{{ slotProps.item.ci_nit }}</span>

                            <span class="ml-2 p-tag p-tag-success p-tag-sm" style="background: #28a745; color: white">
                              NIT
                            </span>
                          </span>

                          <span v-else-if="slotProps.item.tipo_documento === 1">
                            <strong>CI:</strong>
                            <span class="nit-numero-destacado">{{ slotProps.item.ci_nit }}</span>

                            <span class="ml-2 p-tag p-tag-info p-tag-sm" style="background: #17a2b8; color: white">
                              CI
                            </span>
                          </span>

                          <span v-else>
                            <strong>DOC:</strong>
                            <span class="nit-numero-destacado">{{ slotProps.item.ci_nit }}</span>

                            <span class="ml-2 p-tag p-tag-secondary p-tag-sm">
                              {{ obtenerNombreTipoDocumento(slotProps.item.tipo_documento) }}
                            </span>
                          </span>
                        </div>
                      </div>
                    </div>
                  </template>

                  <template #empty>
                    <div class="p-3 text-center">
                      <i class="pi pi-info-circle mb-2" style="font-size: 2rem; color: #64748b"></i>
                      <p class="mb-2">
                        No se encontraron resultados
                        <span v-if="nitClienteSelect && nitClienteSelect.length >= 3">
                          para: <strong>"{{ nitClienteSelect }}"</strong>
                        </span>
                      </p>
                      <Button
                        v-if="nitClienteSelect && nitClienteSelect.length >= 3"
                        label="Registrar Nuevo Cliente"
                        icon="pi pi-plus"
                        class="p-button-sm p-button-success"
                        @click="activarClienteFactura"
                      />
                    </div>
                  </template>
                </AutoComplete>

                <Button
                  :icon="cargandoNit ? 'pi pi-spin pi-spinner' : 'pi pi-search'"
                  class="p-button-warning"
                  v-tooltip.top="'Buscar con Enter'"
                  @click="buscarClientePorNitConEnter"
                  :disabled="!nitClienteSelect || nitClienteSelect.length < 3"
                />

                <Button
                  v-if="'Cliente Crear' in auth.user.permissions"
                  icon="pi pi-id-card"
                  class="p-button-info"
                  v-tooltip.top="'Registrar NIT'"
                  @click="activarClienteFactura"
                />
              </div>

              <div v-if="razon_social" class="p-2" style="background: #f0f8ff; border-radius: 2px; margin-top: 2px">
                <small style="color: #5dade2; font-weight: bold">RAZÓN SOCIAL:</small>
                <span style="margin-left: 5px; color: #2c3e50; font-weight: bold">{{
                  razon_social || 'Sin datos'
                }}</span>
              </div>
            </div>
            <div class="field col-12 md:col-6 mt-2" v-if="!facturar">
              <span><strong>RAZÓN SOCIAL:</strong></span>
              <div class="p-inputgroup">
                <Textarea v-model="razon_social" placeholder="Razón Social" readonly rows="1" autoResize />
              </div>
            </div>
          </div>
          <div class="grid mt-2 mb-0 p-0">
            <div class="field col-12 md:col-5 mb-0" v-if="'Venta ConMedico' in auth.user.permissions">
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">
                  <span><strong>MÉDICO:</strong></span>
                  <Checkbox v-model="medico_referencia" value="medico_referencia" v-tooltip.top="'Médico Referencia'" />
                </span>
                <Dropdown
                  v-if="medico_referencia == 'medico_referencia'"
                  v-model="medicoSelected"
                  :options="medicos"
                  placeholder="Seleccione..."
                  optionLabel="nombre_completo"
                  optionValue="id"
                  :filter="true"
                />
              </div>
            </div>
            <div class="field col-12 md:col-4 mb-0" v-if="'Venta VenderPaquete' in auth.user.permissions">
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">
                  <span v-if="vender_paquete != 'vender_paquete'"><strong>PAQUETE:</strong></span>
                  <Checkbox v-model="vender_paquete" value="vender_paquete" v-tooltip.top="'Vender Paquete'" />
                </span>
                <Dropdown
                  v-if="vender_paquete == 'vender_paquete'"
                  v-model="paqueteSelected"
                  :options="paqueteproductos"
                  placeholder="Paquete..."
                  optionLabel="nombre"
                  optionValue="id"
                  :filter="true"
                />
                <Button
                  :disabled="!paqueteSelected"
                  v-if="vender_paquete == 'vender_paquete'"
                  icon="pi pi-plus"
                  class="p-button-info"
                  v-tooltip.top="'Agregar Paquete al Detalle'"
                  @click="agregarProductosPaqueteAlDetalle"
                />
              </div>
            </div>
            <div class="field col-12 md:col-3 mb-0" v-if="'Venta Proforma' in auth.user.permissions">
              <div class="p-inputgroup">
                <span class="p-inputgroup-addon">
                  <span v-if="!buscar_proforma"><strong>PROFORMA:</strong></span>
                  <Checkbox v-model="buscar_proforma" :binary="true" v-tooltip.top="'Buscar Proforma'" />
                </span>
                <InputText
                  v-if="buscar_proforma"
                  v-model="proforma_codigo"
                  placeholder="Código Proforma"
                  @keyup.enter="agregarProductosProforma"
                />
                <Button
                  :disabled="!proforma_codigo"
                  v-if="buscar_proforma"
                  icon="pi pi-search"
                  class="p-button-info"
                  v-tooltip.top="'Buscar Proforma'"
                  @click="agregarProductosProforma"
                />
              </div>
            </div>
          </div>
          <Panel toggleable :collapsed="false" class="shadow-2" @update:collapsed="actualizarPanelMasFiltros">
            <template #header>
              <div class="p-inputgroup">
                <AutoComplete
                  autofocus
                  field="descripcion"
                  v-model="productoSelecionado"
                  placeholder="Buscar... Nombre de Producto"
                  v-tooltip.top="'Buscar Producto por Nombre'"
                  :suggestions="productosListadoFiltrado"
                  @keyup.enter="buscarProducto($event)"
                  >
                  <!-- scrollHeight="450px" -->
                  <template #item="slotProps">
                    <div
                      class="tabla-fila"
                      :class="
                        (slotProps.item.stock.length > 0 ? sinDecimal(slotProps.item.stock[0].cantidad) : 0) > 0
                          ? ''
                          : 'sin-stock'
                      "
                    >
                      <!-- PRODUCTO CON UM -->
                      <div
                        class="td td-producto"
                        :class="computedBuscarProductoPorSelected ? 'con-caso' : 'sin-caso'"
                        :title="slotProps.item.descripcion"
                      >
                        {{ slotProps.item.descripcion }}
                        <span class="um-badge">{{ soloPrimeraPalabra(slotProps.item.unidad_medida_nombre) }}</span>
                      </div>

                      <!-- FÁBRICA -->
                      <div class="td td-fabrica" :title="slotProps.item.fabrica_nombre">
                        {{ slotProps.item.fabrica_nombre }}
                      </div>

                      <!-- CASO USO -->
                      <div
                        class="td td-caso"
                        v-if="
                          computedBuscarProductoPorSelected &&
                          slotProps.item.caso_uso != null &&
                          slotProps.item.caso_uso != ''
                        "
                        v-tooltip.top="slotProps.item.caso_uso"
                      >
                        {{ slotProps.item.caso_uso.substring(0, 12) }}...
                      </div>

                      <!-- STOCK -->
                      <div
                        class="td td-stock"
                        :class="
                          stockClass(slotProps.item.stock.length > 0 ? sinDecimal(slotProps.item.stock[0].cantidad) : 0)
                        "
                      >
                        {{ slotProps.item.stock.length > 0 ? sinDecimal(slotProps.item.stock[0].cantidad) : 0 }}
                      </div>

                      <!-- PRECIO -->
                      <div class="td td-precio">
                        Bs.
                        <span v-if="!clienteSelect || clienteSelect.tipo_cliente_id == 1">
                          {{ slotProps.item.stock.length > 0 ? slotProps.item.stock[0].ultimo_precio : '-' }}
                        </span>
                        <span v-else-if="clienteSelect.tipo_cliente_id == 2">
                          {{
                            slotProps.item.stock.length > 0
                              ? slotProps.item.stock[0].pv2
                              : slotProps.item.stock[0].ultimo_precio
                          }}
                        </span>
                        <span v-else-if="clienteSelect.tipo_cliente_id == 3">
                          {{
                            slotProps.item.stock.length > 0
                              ? slotProps.item.stock[0].pv3
                              : slotProps.item.stock[0].ultimo_precio
                          }}
                        </span>
                      </div>
                    </div>
                  </template>
                </AutoComplete>

                <Button
                  :disabled="!productoSelecionado"
                  icon="pi pi-search"
                  class="p-button-warning"
                  v-tooltip.top="'Buscar Producto'"
                  @click="buscarProducto($event)"
                  :loading="cargandoProductoBusqueda"
                />
                <Button
                  icon="pi pi-bars"
                  class="p-button-info"
                  v-tooltip.top="'VER RESULTADOS DE BUSQUEDA'"
                  @click="activarModalProductosFiltrados"
                  :disabled="productosListadoFiltrado.length == 0"
                ></Button>
              </div>
            </template>

            <div class="grid">
              <div class="col-12 md:col-4" v-show="false">
                <span><strong>C&Oacute;D BARRA:</strong></span>
                <AutoComplete
                  field="codigo_barra"
                  v-model="codProdSelected"
                  :suggestions="codProdListadoFiltrado"
                  v-tooltip.top="'Código'"
                  placeholder="Código..."
                  @item-select="buscarCodProducto"
                  @complete="buscarCodProducto"
                  @keyup.enter="buscarCodProducto"
                  autocomplete="off"
                />
              </div>
              <div class="col-12 flex flex-align-left">
                <div v-for="filtro of buscarProductoPorListado" :key="filtro.value" class="col-3 mr-1">
                  <div class="p-inputgroup flex align-items-center">
                    <Checkbox
                      v-model="buscarProductoPorSelected"
                      :inputId="filtro.value"
                      name="filtro"
                      :value="filtro.value"
                    />
                    <span class="ml-1 text-900 font-bold" :for="filtro.value">{{ filtro.label }}</span>
                  </div>
                </div>
              </div>
            </div>
          </Panel>
          <DataTable
            v-if="this.mostrarTablaFechasVencimiento == true"
            ref="fechas_vencimiento"
            :value="fechas_vencimiento"
            class="p-datatable-sm mt-2"
            responsiveLayout="scroll"
            scrollHeight="400px"
            :rowhover="true"
            stripedRows
            showGridlines
            selectionMode="single click"
            :style="{ border: '1px solid #000000' }"
          >
            <template #empty> Debe seleccionar un producto </template>
            <Column field="nombre_producto" header="DESCRIPCIÓN/PRODUCTO">
              {{ data.nombre_producto ?? '' }}
            </Column>
            <Column class="text-center" field="cantidad" header="EN STOCK">
              <template #body="{ data }">
                <div :class="stockClass(data.cantidad)">
                  {{ convertirNumeroGermanicFormat(data.cantidad) }}
                </div>
              </template>
            </Column>
            <Column
              class="text-right"
              field="ultimo_precio"
              header="PRECIO"
              style="font-weight: bold; font-size: 1.2em"
            >
              <template #body="{ data }">
                {{ convertirNumeroGermanicFormat(data.ultimo_precio ?? 0) }}
              </template>
            </Column>
            <Column class="text-center" field="fecha_vence" header="VENCIEMIENTO">
              <template #body="{ data }" style="font-weight: bold; font-size: 1.3em">
                {{ data.fecha_vence == '1905-03-14' ? 'Sin Fecha' : formatDate(data.fecha_vence) }}
              </template>
            </Column>
            <Column class="text-center" field="lote" header="LOTE">
              {{ data.lote ?? '0' }}
            </Column>
            <Column header="ACCIONES" style="text-align: center">
              <template #body="slotProps">
                <Button
                  icon="pi pi-plus"
                  class="p-button-rounded p-button-info mr-1"
                  @click="agregarDetalleVenta(slotProps.data)"
                  v-tooltip.top="'Agregar al Detalle'"
                  :disabled="slotProps.data.cantidad <= 0"
                />
              </template>
            </Column>
          </DataTable>
          <DataTable
            ref="dt_venta_detalle"
            class="p-datatable-sm mt-2"
            dataKey="id"
            :value="productosVentas"
            responsiveLayout="scroll"
            scrollHeight="400px"
            editMode="cell"
            @cell-edit-complete="guardandoCambiosCelda"
            :rowhover="true"
            stripedRows
            showGridlines
            selectionMode="single click"
          >
            <template #empty>
              <span
                class="flex align-items-center justify-content-center"
                style="background-color: #f8d7da; padding: 5px; border-radius: 5px; color: #721c24"
                >Busca Productos para agregar al Detalle!</span
              ></template
            >
            <Column header="#">
              <template #body="slotProps">
                {{ 1 + slotProps.index }}
              </template>
            </Column>
            <Column field="nombre_producto" header="DESCRIPCIÓN/PRODUCTO">
              <template #body="{ data }">
                <span>
                  <strong>{{ data.nombre_producto }}</strong
                  ><strong> ** </strong>
                  <span v-if="data.nombre_fabrica != null">
                    {{ data.nombre_fabrica }}
                  </span>
                  <span v-else-if="data.fabrica_nombre != null">
                    {{ data.fabrica_nombre }}
                  </span>
                  <span v-else>{{ data.producto.fabrica_nombre != null ? data.producto.fabrica_nombre : '' }}</span>
                  <span v-if="mostrarFechaEnDetalle">
                    <strong> ** </strong>
                    <span v-if="data.fecha_vence == '1905-03-14'" style="color: red; font-weight: bold">S/F</span>
                    <span v-else style="color: green; font-weight: bold"> {{ formatDate(data.fecha_vence) }}</span>
                  </span>
                </span>
              </template>
            </Column>
            <Column field="cantidad" header="STOCK" class="text-center strong">
              <template #body="{ data }">
                <span :class="claseEstado(data)">
                  <strong> {{ sinDecimal(data.cantidad) }}</strong>
                </span>
              </template>
            </Column>
            <Column
              class="text-right strong bg-green-200"
              field="cantidad_venta"
              header="CANTIDAD"
              style="color: #000; font-weight: bold"
            >
              <template #body="slotProps">
                {{ slotProps.data.cantidad_venta }}
              </template>
              <template #editor="{ data, field }">
                <InputNumber v-model="data[field]" input-class="flex-row-reverse" locale="de-DE" :min="1" />
              </template>
            </Column>
            <Column class="text-right strong" field="ultimo_precio" header="PRECIO">
              <template #body="slotProps">
                {{ convertirNumeroGermanicFormat(slotProps.data.ultimo_precio) }}
              </template>
              <template #editor="{ data, field }" v-if="'Venta EditarPrecio' in this.auth.user.permissions">
                <InputNumber
                  v-model="data[field]"
                  :inputClass="'text-right'"
                  :min="1"
                  :minFractionDigits="2"
                  :maxFractionDigits="2"
                  locale="de-DE"
                />
              </template>
            </Column>
            <Column
              v-if="aplica_descuento"
              class="flex-row-reverse strong bg-green-200"
              field="descuento_neto"
              header="DESC."
              style="color: #000; font-weight: bold"
            >
              <template #body="slotProps">
                {{ convertirNumeroGermanicFormat(slotProps.data.descuento_neto) }}
              </template>
              <template #editor="slotProps">
                <InputNumber
                  :inputClass="'text-right'"
                  :min="0"
                  :minFractionDigits="2"
                  :maxFractionDigits="2"
                  locale="de-DE"
                  v-model="slotProps.data.descuento_neto"
                />
              </template>
            </Column>
            <Column class="text-right" field="total" header="TOTAL">
              <template #body="slotProps">
                {{
                  convertirNumeroGermanicFormat(
                    slotProps.data.ultimo_precio * slotProps.data.cantidad_venta - slotProps.data.descuento_neto
                  )
                }}
              </template>
            </Column>
            <Column>
              <template #header>
                <i class="pi pi-check"></i>
              </template>
              <template #body="slotProps">
                <Checkbox
                  v-model="slotProps.data.entregado"
                  value="entregado"
                  :disabled="slotProps.data.cantidad_venta == 0"
                  v-tooltip.top="'Entregado'"
                />
              </template>
            </Column>
            <Column class="strong" style="min-width: 20px">
              <template #header>
                <i class="pi pi-trash"></i>
              </template>
              <template #body="slotProps">
                <Button
                  @click="quitarProductoDetalle(slotProps)"
                  v-tooltip.top="'Quitar Producto'"
                  icon="pi pi-times"
                  class="p-button-rounded p-button-danger p-button-text"
                />
              </template>
            </Column>
          </DataTable>
        </div>
      </div>
      <div class="col-12 md:col-4">
        <div class="card">
          <h4><strong>TOTALES DE VENTAS:</strong></h4>
          <div class="p-fluid formgrid grid">
            <table class="field col-12 md:col-12">
              <tr>
                <td>
                  <strong>SUB TOTAL:</strong>
                </td>
                <td class="text-right">{{ convertirNumeroGermanicFormat(subtotal) }} Bs.</td>
              </tr>
              <tr v-if="aplica_descuento">
                <td>
                  <strong>DESCUENTO:</strong>
                </td>
                <td class="text-right">{{ convertirNumeroGermanicFormat(descuento) }} Bs.</td>
              </tr>
              <tr>
                <td>
                  <h4><strong>TOTAL VENTA:</strong></h4>
                </td>
                <td class="text-right">
                  <h2>{{ convertirNumeroGermanicFormat(total_venta) }} Bs.</h2>
                </td>
              </tr>
              <tr v-if="tipo_pagoSelect == 2">
                <td>
                  <strong>A CUENTA:</strong>
                </td>
                <td class="text-right">{{ convertirNumeroGermanicFormat(a_cuenta + monto_pago) }} Bs.</td>
              </tr>
              <tr v-if="tipo_pagoSelect == 2">
                <td>
                  <strong>SALDO:</strong>
                </td>
                <td class="text-right">
                  {{ convertirNumeroGermanicFormat(total_venta - a_cuenta - monto_pago) }}
                  Bs.
                </td>
              </tr>
            </table>

            <div v-if="aplica_descuento && descuentos_aplicables.length > 0" class="field col-12 md:col-12">
              <div style="background: #eff6ff; border: 1px solid #3b82f6; border-radius: 4px; padding: 6px">
                <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 4px">
                  <strong style="font-size: 0.85rem; color: #1e40af">
                    <i class="pi pi-percentage" style="font-size: 0.75rem"></i> DESCUENTOS APLICADOS
                  </strong>
                  <span style="font-size: 0.9rem; color: #059669; font-weight: 700">
                    Total:
                    {{
                      parseFloat(
                        descuentos_aplicables.reduce((sum, d) => sum + parseFloat(d.config.porcentaje), 0)
                      ).toFixed(2)
                    }}%
                  </span>
                </div>
                <div
                  v-for="desc in descuentos_aplicables"
                  :key="desc.config.id"
                  style="display: flex; justify-content: space-between; padding: 2px 0; font-size: 0.8rem"
                >
                  <span style="font-weight: 500">{{ desc.config.nombre }}</span>
                  <span style="color: #059669; font-weight: 600">
                    {{ parseFloat(desc.config.porcentaje).toFixed(2) }}% ({{
                      convertirNumeroGermanicFormat(desc.monto)
                    }}
                    Bs)
                  </span>
                </div>
              </div>
            </div>

            <div v-if="aplica_descuento && mostrar_advertencia_descuento" class="field col-12 md:col-12">
              <div style="background: #fef3c7; border-left: 3px solid #f59e0b; border-radius: 3px; padding: 6px 8px">
                <div style="display: flex; align-items: center; gap: 6px">
                  <i class="pi pi-exclamation-triangle" style="color: #d97706; font-size: 1rem"></i>
                  <div style="flex: 1; font-size: 0.8rem">
                    <strong style="color: #92400e">
                      Válido hasta: <span style="color: #dc2626">{{ formatearFecha(fecha_limite_descuento) }}</span>
                    </strong>
                    <p style="margin: 0; color: #78350f; font-size: 0.75rem">
                      Si paga después, se anulará automáticamente.
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="field col-12 md:col-12" v-if="facturar" v-show="false">
              <span><strong>ACTIVIDAD ECONOMICA:</strong></span>
              <div class="p-inputgroup">
                <Dropdown
                  v-model="actividad_economica_selected"
                  :options="actividades_economicas"
                  option-label="descripcion"
                  option-value="codigo"
                  placeholder="Seleccione una actividad economica"
                  @change="cambiarActividadEconomica"
                />
              </div>
            </div>
            <div class="p-field field col-12 md:col-12">
              <div class="p-inputgroup">
                <template v-if="permitir_facturar">
                  <Checkbox
                    class="mr-1"
                    value="facturar"
                    v-model="facturar"
                    :binary="true"
                    v-tooltip.top="'Facturar'"
                    :disabled="'Venta Facturar' in auth.user.permissions == false || total_venta == 0"
                  /><span class="p-tag p-tag-rounded p-tag-danger">ENVIAR</span>
                </template>
                <Checkbox
                  class="ml-2 mr-1"
                  :disabled="'Venta Descuentos' in auth.user.permissions == false || total_venta == 0"
                  :binary="true"
                  v-model="aplica_descuento"
                  v-tooltip.top="'Aplicar Descuento'"
                />
                <span class="p-tag p-tag-rounded p-tag-warning">DESCUENTO</span>
                <Checkbox class="ml-2 mr-1" :binary="true" v-tooltip.top="'Observación'" v-model="observacion_check" />
                <span class="p-tag p-tag-rounded p-tag-info">OBSERVACIÓN</span>
              </div>
            </div>
            <div class="field col-12 md:col-12" v-if="observacion_check">
              <Textarea v-model="observacion" rows="3" autoResize placeholder="Glosa/observación" />
            </div>
            <template v-if="aplica_descuento">
              <table class="field col-12 md:col-12">
                <tr v-show="true">
                  <td>
                    <strong>DESC. NETO :</strong>
                  </td>
                  <td class="text-right">
                    <InputNumber
                      v-model="descuento"
                      locale="de-DE"
                      input-class="text-right"
                      :min="0"
                      :max="subtotal"
                      :minFractionDigits="2"
                      :maxFractionDigits="2"
                      placeholder="descuento neto"
                      @keyup="calcular_agregar_des_total_venta"
                      :disabled="aplica_descuento"
                    />
                  </td>
                  <td class="text-right">
                    <Button
                      icon="pi pi-check"
                      class="p-button-outlined p-button-secondary"
                      v-tooltip.top="'Descuento neto'"
                      @click="calcular_agregar_des_total_venta"
                      :disabled="aplica_descuento"
                    />
                  </td>
                </tr>
                <tr>
                  <td>
                    <strong>DESCUENTO %:</strong>
                  </td>
                  <td class="text-right strong">
                    <InputNumber
                      v-model="desc_venta_porcentaje"
                      locale="de-DE"
                      input-class="text-right"
                      :min="0"
                      :max="100"
                      :minFractionDigits="2"
                      :maxFractionDigits="2"
                      placeholder="descuento %"
                      @keyup="calcular_agregar_des_total_venta_porcentaje"
                    />
                  </td>
                  <td class="text-right">
                    <Button
                      v-tooltip.top="'Descuento %'"
                      icon="pi pi-check"
                      class="p-button-outlined p-button-secondary"
                      @click="calcular_agregar_des_total_venta_porcentaje"
                    />
                  </td>
                </tr>
              </table>
            </template>
            <div class="p-field field col-12 md:col-12">
              <div class="p-inputgroup">
                <template v-if="'Venta Credito' in auth.user.permissions">
                  <Checkbox
                    class="mr-1"
                    v-model="a_credito_check"
                    :binary="true"
                    v-tooltip.top="'Seleccionar tipo de pago'"
                    :disabled="'Venta Credito' in auth.user.permissions == false || total_venta == 0"
                  /><span :class="'p-tag p-tag-rounded' + (total_venta == 0 ? ' bg-black-alpha-20' : ' p-tag-primary')"
                    >A CRÉDITO</span
                  >
                </template>
                <template v-if="'Venta M.Pagos' in auth.user.permissions">
                  <Checkbox
                    class="ml-2 mr-1"
                    v-model="metodo_pago_check"
                    :binary="true"
                    :disabled="'Venta M.Pagos' in auth.user.permissions == false || total_venta == 0"
                    v-tooltip.top="'Seleccionar Método de Pago'"
                  /><span :class="'p-tag p-tag-rounded' + (total_venta == 0 ? ' bg-black-alpha-20' : ' p-tag-success')"
                    >PAGO QR</span
                  >
                </template>
                <template v-if="'Proforma Crear' in auth.user.permissions">
                  <Checkbox
                    class="mr-1 ml-1"
                    value="proforma"
                    :binary="true"
                    v-tooltip.top="'Crear como proforma'"
                    v-model="proforma"
                    :disabled="total_venta == 0 || facturar == 1"
                  />
                  <span :class="'p-tag p-tag-rounded' + (total_venta == 0 ? ' bg-black-alpha-20' : ' p-tag-danger')"
                    >PROFORMA</span
                  >
                </template>
              </div>
            </div>
            <div class="field col-12 md:col-12">
              <table style="width: 100%">
                <!-- <tr v-if="a_credito_check">
                  <td>
                    <strong>TIPO DE PAGO: </strong>
                  </td>
                  <td>
                    <Dropdown
                      v-model="tipo_pagoSelect"
                      :options="tipo_pagos"
                      optionLabel="nombre"
                      optionValue="id"
                    />
                  </td>
                </tr>
                <tr v-if="tipo_pagoSelect == 2">
                  <td>
                    <strong>D&Iacute;AS CR&Eacute;DITO: </strong>
                  </td>
                  <td>
                    <InputNumber
                      v-model="dias_credito"
                      :min="1"
                      :inputClass="'text-right'"
                      locale="de-ED"
                      :useGrouping="false"
                      showButtons
                    />
                  </td>
                </tr> -->
                <tr v-if="tipo_pagoSelect == 2">
                  <td>
                    <strong>EFECTIVO: </strong>
                  </td>
                  <td>
                    <InputNumber
                      v-model="a_cuenta"
                      :min="0"
                      :max="total_venta - monto_pago - 1"
                      :inputClass="'text-right'"
                      locale="de-ED"
                      :minFractionDigits="2"
                      :useGrouping="false"
                      placeholder="a cuenta efectivo"
                    />
                  </td>
                </tr>
                <tr v-if="metodo_pago_check">
                  <td>
                    <strong>M&Eacute;TODO PAGO: </strong>
                  </td>
                  <td>
                    <Dropdown
                      :disabled="estado_qr_generado == 1"
                      v-model="metodo_pagoSelect"
                      :options="metodo_pagos"
                      optionLabel="nombre"
                      optionValue="id"
                    />
                  </td>
                </tr>
                <tr v-if="metodo_pagoSelect == 6 && permitir_pago_qr_banco">
                  <td>
                    <strong>GENERAR QR: </strong>
                  </td>
                  <td>
                    <Button
                      :disabled="estado_qr_generado == 1"
                      label="GENERAR QR"
                      icon="pi pi-qrcode"
                      class="p-button-info"
                      @click="generarQR"
                      :loading="generando_qr"
                    />
                  </td>
                </tr>
                <tr v-if="metodo_pagoSelect == 6 && generar_qr">
                  <td class="text-center">
                    <span v-if="estado_qr_generado == 0" style="color: #d9534f; font-size: 1rem; text-align: center">
                      <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i><br />
                      <strong>PENDIENTE DE PAGO...</strong>
                    </span>
                    <span v-if="estado_qr_generado == 1" style="color: #28a745; font-size: 1rem; text-align: center">
                      <i class="pi pi-check" style="font-size: 2rem"></i><br />
                      <strong>PAGADO</strong>
                    </span>
                    <span v-if="estado_qr_generado == 9" style="color: #721c24; font-size: 1rem; text-align: center">
                      <i class="pi pi-times" style="font-size: 2rem"></i><br />
                      <strong>ANULADO</strong>
                    </span>
                  </td>

                  <td>
                    <Image :src="'data:image/png;base64, ' + qrImage" width="150" preview></Image>
                    <Button
                      v-if="estado_qr_generado != 1"
                      label="CANCELAR QR"
                      icon="pi pi-times"
                      class="p-button-danger"
                      @click="cancelarQR"
                      :loading="cancelando_qr"
                    />
                  </td>
                </tr>
                <tr v-if="metodo_pagoSelect == 2 && facturar == 1">
                  <td>
                    <strong>Nº TARJETA: </strong>
                  </td>
                  <td>
                    <div class="flex flex-column">
                      <InputText
                        v-model="nro_tarjeta"
                        type="text"
                        class="text-right"
                        placeholder="Ej: 12345678"
                        maxlength="8"
                        @input="validarTarjetaInput"
                        @keypress="soloNumeros($event)"
                        :class="{
                          'p-invalid': nro_tarjeta && nro_tarjeta.length !== 8
                        }"
                      />
                      <small
                        class="mt-1"
                        :class="nro_tarjeta && nro_tarjeta.length === 8 ? 'text-green-600' : 'p-error'"
                      >
                        <i
                          :class="
                            nro_tarjeta && nro_tarjeta.length === 8
                              ? 'pi pi-check-circle'
                              : 'pi pi-exclamation-triangle'
                          "
                        ></i>
                        {{ nro_tarjeta ? nro_tarjeta.length : 0 }}/8 dígitos
                      </small>
                    </div>
                  </td>
                </tr>
                <tr v-if="metodo_pagoSelect != 1">
                  <td>
                    <strong>MONTO PAGO: </strong>
                  </td>
                  <td>
                    <InputNumber
                      v-model="monto_pago"
                      :min="0"
                      :max="total_venta - a_cuenta"
                      :inputClass="'text-right'"
                      locale="de-ED"
                      :useGrouping="false"
                      :minFractionDigits="2"
                      showButtons
                      placeholder="monto pago transferencias"
                    />
                  </td>
                </tr>
              </table>
            </div>
            <div class="field col-12 md:col-6 hidden">
              <span><strong>Cotizaci&oacute;n</strong></span>
              <Checkbox class="ml-3" value="cotizar" v-model="cotizar" />
            </div>
            <table class="field col-12 md:col-12">
              <tr>
                <td>
                  <strong>RECIBIDO:</strong>
                </td>
                <td class="text-right">
                  <InputNumber
                    v-model="efectivo"
                    :min="total_venta - monto_pago - a_cuenta"
                    locale="de-DE"
                    input-class="text-right"
                    :minFractionDigits="2"
                    inputId="locale-german"
                    :disabled="metodo_pagoSelect != 1 ? true : false || a_credito_check"
                  />
                </td>
              </tr>
              <tr>
                <td>
                  <strong>
                    <h2>CAMBIO:</h2>
                  </strong>
                </td>
                <td class="text-right p-invalid">
                  <strong>
                    <h1>{{ convertirNumeroGermanicFormat(cambio) }} Bs.</h1>
                  </strong>
                </td>
              </tr>
            </table>
            <div class="col-12 md:col-12 flex justify-content-end">
              <Button
                icon="pi pi-refresh"
                class="p-button-warning"
                v-tooltip.top="'Detener y Volver a Empezar'"
                @click="guardando = false"
                v-if="guardando"
                :disabled="productosVentas.length == 0"
              />
              <Button
                :label="proforma == 1 ? 'REGISTRAR PROFORMA' : facturar == 1 ? 'REGISTRAR FACTURA' : 'REGISTRAR VENTA'"
                icon="pi pi-save"
                v-tooltip.top="
                  proforma == 1 ? 'Registrar Proforma' : facturar == 1 ? 'Registrar Factura' : 'Registrar Venta'
                "
                class="p-button-info p-button-lg"
                @click="guardarVenta"
                :disabled="total_venta == 0"
                :loading="guardando"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="grid" v-else>
      <Message class="col-12" :severity="'info'" :closable="false">
        <div class="flex align-items-center justify-content-center">
          <span> PARA REALIZAR VENTAS DEBE ABRIR LA CAJA </span>
          <Button
            label="APERTURAR CAJA"
            class="p-button-success p-button-lg ml-3"
            icon="pi pi-lock-open"
            v-tooltip.top="'Abrir Caja'"
            @click="this.$router.push({ name: 'caja' })"
          />
        </div>
      </Message>
    </div>
  </div>
  <div v-else>
    <div class="grid">
      <h3 class="col-12">Verificando caja ...</h3>
      <ProgressSpinner
        style="width: 50px; height: 50px"
        strokeWidth="8"
        fill="var(--surface-ground)"
        animationDuration=".5s"
        class="col-12"
      />
    </div>
  </div>

  <!-- MODAL DE LOADING PARA FACTURACIÓN -->
  <Dialog
    v-model:visible="facturando"
    :modal="true"
    :closable="false"
    :draggable="false"
    :style="{ width: '300px' }"
    header="PROCESANDO FACTURA"
    class="modal-facturacion"
  >
    <div class="loading-content">
      <ProgressSpinner style="width: 40px; height: 40px" strokeWidth="8" fill="transparent" animationDuration="1s" />

      <div class="loading-info mt-4">
        <p class="text-secondary">{{ detalleFacturacion }}</p>

        <div class="warning-box mt-4">
          <i class="pi pi-info-circle mr-2"></i>
          <span>Esto puede tardar unos segundos...</span>
        </div>
      </div>
    </div>
  </Dialog>

  <TimeoutFacturaDialog
    v-if="timeoutDialogVisible"
    v-model="timeoutDialogVisible"
    :venta-id="timeoutVentaId"
    :loading="buscandoFactura"
    @buscar-factura="buscarFacturaTimeout"
    @ir-detalle="irADetalleVenta"
  />
  <ClienteCreate
    v-if="clienteModal"
    :show="clienteModal"
    :cliente="cliente"
    @closeModal="cerrarModalCliente"
    @actualizarListado="cargarClientesListado"
  >
  </ClienteCreate>
  <ClienteFactura
    v-if="clienteFacturaModal"
    :show="clienteFacturaModal"
    :cliente_factura="cliente_factura"
    @closeModal="cerrarModalClienteFactura"
    @actualizarListado="cargarClienteFactura"
  >
  </ClienteFactura>
  <ProducoListadoModal
    v-if="productosFiltrados"
    @closeModal="cerrarModalProductoResultados"
    :show="productosResultados"
    :productos="productosFiltrados"
    @agregarProductos="agregarProductos"
  ></ProducoListadoModal>
</template>

<script>
import ClienteService from '@/service/ClienteService'
import ProductService from '@/service/ProductService'
import VentaService from '@/service/VentaService'
import ClienteCreate from '@/module/clientes/ClienteCreate.vue'
import ClienteFactura from '@/module/clientes/ClienteFactura.vue'
import CajaService from '@/service/CajaService'
import { useAuth } from '@/stores'
import TipoPagoService from '@/service/TipoPagoService'
import MetodoPagoService from '@/service/MetodoPagoService'
import PaqueteProductoService from '@/service/PaqueteProductoService'
import FacturaService from '@/service/FacturaService'
import ParametrosSistemaService from '@/service/ParametrosSistemaService'
import ProducoListadoModal from '@/module/productos/ProductoListadoModal.vue'
import EmpresaService from '@/service/EmpresaService' /*
import LaboratorioService from "@/service/LaboratorioService"; */
import { debounce } from '@/helpers/debounce'
import TimeoutFacturaDialog from '@/components/TimeoutFacturaDialog.vue'
import { has } from 'lodash'

export default {
  components: {
    ClienteCreate,
    ClienteFactura,
    ProducoListadoModal,
    TimeoutFacturaDialog
  },
  data() {
    return {
      masFiltrosBusqueda: false,
      buscarProductoPorSelected: ['nombre_comercial'],
      buscarProductoPorListado: [
        { label: 'Nom. Com.', value: 'nombre_comercial' },
        { label: 'P Act.', value: 'principio_activo' },
        { label: 'Cód. Barra', value: 'codigo' },
        { label: 'Acc. Farm.', value: 'accion_farmacologica' }
      ],
      permitir_facturar: false,
      facturar: false,
      cotizar: false,
      guardando: false,
      clienteSelect: null,
      clientes: [],
      razon_social: null,
      nit: 0,
      productoSelecionado: null,
      productosSelecionado: null,
      productosListadoFiltrado: [],
      productosVentas: [],
      stockSucursales: [],
      subtotal: 0,
      descuento: 0,
      total_venta: 0,
      efectivo: 0,
      monto_pago: 0, //monto de pago en efectivo
      clienteModal: false,
      clienteFacturaModal: false,
      cliente: { estado: { label: 'Activo', value: 1 } },
      clienteFactura: { estado: { label: 'Activo', value: 1 } },
      medicoModal: false,
      medico: { estado: { label: 'Activo', value: 1 } },
      fecha_venta: null,
      permitirVenta: false,
      cargandoComponente: false,
      sucursal_id: null,
      caja: null,
      codProdSelected: '',
      codProdListadoFiltrado: [],
      desc_venta_porcentaje: null,
      aplica_descuento: false,
      tipo_pagos: [],
      tipo_pagoSelect: 1,
      metodo_pagos: [],
      metodo_pagoSelect: 1,
      dias_credito: 0,
      a_cuenta: 0,
      saldo: 0,
      observacion: '',
      observacion_check: false,
      a_credito_check: false,
      metodo_pago_check: false,
      stockClass: (data) => {
        if (data <= 0) {
          return 'outofstock'
        } else if (data <= 10) {
          return 'lowstock'
        } else {
          return 'instock'
        }
      },
      claseEstado: (data) => {
        if (data.cantidad <= 0) {
          return 'outofstock'
        } else if (data.cantidad <= 10) {
          return 'lowstock'
        } else {
          return 'instock'
        }
      },
      vender_paquete: false,
      paqueteSelected: null,
      paqueteproductos: [],
      paqueteproductosListado: [],
      entregado: 0,
      medico_referencia: false,
      medicos: [],
      medicoSelected: null,
      productosResultados: false,
      productosFiltrados: [],
      actividades_economicas: [],
      actividad_economica_selected: null,
      nro_tarjeta: null,
      filtrosRadio: 'precio_venta',
      cliente_factura: {},
      nombre_sucursal: null,
      parametros_sistema: {},
      laboratorios: [],
      laboratorioSelected: null,
      proforma: false,
      fechas_vencimiento: [],
      qr_cobros: null,
      mostrarTablaFechasVencimiento: false,
      buscar_proforma: false,
      proforma_codigo: null,
      proforma_id: null,
      imprimirFactura: false,
      imprimirVenta: false,
      permisoActivarModalProductos: false,
      mostrarFechaEnDetalle: false,
      venta_duplicada: null,
      permitir_pago_qr_banco: false, //permiso para generar qr de banco
      generar_qr: false,
      qrImage: '',
      qrId: null,
      generando_qr: false,
      estado_qr_generado: 0,
      cancelando_qr: false,
      verificarQRInterval: null,
      punto_venta_id: null,
      codigo_punto_venta: null,

      cargandoNit: false,
      nitClienteSelect: null,
      nitClientesFiltrados: [],

      // Variables para modal de facturación
      facturando: false,
      detalleFacturacion:
        'Enviando factura al sistema de impuestos. Por favor no cierre esta ventana ni realice otras acciones hasta que se complete el proceso.',

      // Variables para TimeoutFacturaDialog
      timeoutDialogVisible: false,
      timeoutVentaId: null,
      buscandoFactura: false,

      cacheBusquedaCliente: new Map(),
      cacheBusquedaProducto: new Map(),
      cacheBusquedaNit: new Map(),
      cargandoCliente: false,

      cargandoProductoBusqueda: false,

      descuentos_config: [],
      descuentos_aplicables: [],
      descuento_calculado_auto: 0,
      descuento_calculado_auto_anterior: 0,
      mostrar_advertencia_descuento: false,
      fecha_limite_descuento: null,
      descuentos_configurables: false
    }
  },
  clienteService: null,
  productService: null,
  ventaService: null,
  cajaService: null,
  auth: null,
  tipoPagoService: null,
  metodoPagoService: null,
  paqueteProductoService: null,
  facturaService: null,
  parametrosSistemaService: null,
  empresaService: null /*
  laboratorioService: null, */,
  created() {
    this.auth = useAuth()
    this.clienteService = new ClienteService()
    this.productService = new ProductService()
    this.ventaService = new VentaService()
    this.cajaService = new CajaService()
    this.tipoPagoService = new TipoPagoService()
    this.metodoPagoService = new MetodoPagoService()
    this.paqueteProductoService = new PaqueteProductoService()
    this.facturaService = new FacturaService()
    this.parametrosSistemaService = new ParametrosSistemaService()
    this.empresaService = new EmpresaService()

    this.buscarProductoDebounced = debounce(this.buscarProductoImpl, 400)

    this.buscarClientePorNitDebounced = debounce(this.buscarClientePorNitImpl, 500)
    this.buscarClienteDebounced = debounce(this.buscarClienteImpl, 400)
  },
  mounted() {
    this.datos_venta_general()
    this.obtenerDescuentosConfig()
    if ('Venta Duplicar' in this.auth.user.permissions) {
      let productosVentas = this.$route.params.productosVentas ? JSON.parse(this.$route.params.productosVentas) : []
      if (productosVentas.length) {
        this.agregarProductosVendidos(productosVentas)
      }
    }
  },
  computed: {
    // si mi venta es al credito entonces en efectivo se registra el monto  a cuenta el cambio es el total efectivo - a cuenta
    cambio() {
      if (this.tipo_pagoSelect == 2) {
        return this.efectivo - this.a_cuenta
      } else {
        return this.efectivo + this.monto_pago - this.total_venta
      }
    },
    computedBuscarProductoPorSelected() {
      return this.buscarProductoPorSelected.includes('principio_activo')
    }
  },
  beforeUnmount() {
    this.limpiarCaches()
    if (this.verificarQRInterval) {
      clearInterval(this.verificarQRInterval)
    }
  },
  methods: {
    // OBTENER DESCUENTOS CONFIGURABLES
    async obtenerDescuentosConfig() {
      try {
        const response = await this.ventaService.obtenerDescuentosActivos()
        this.descuentos_config = response.descuentos || []
      } catch (error) {
        console.error('Error al obtener descuentos:', error)
      }
    },

    async calcularDescuentosAplicables() {
      if (this.productosVentas.length === 0) {
        this.descuentos_aplicables = []
        this.descuento_calculado_auto = 0
        return
      }

      const subtotal = this.subtotal

      try {
        const response = await this.ventaService.calcularDescuentosAplicables({
          subtotal: subtotal,
          tipo_pago_id: this.tipo_pagoSelect
        })

        this.descuentos_aplicables = response.descuentos_aplicables || []
        this.descuento_calculado_auto = response.total_descuento || 0

        this.descuento = this.descuento_calculado_auto
        this.descuento_calculado_auto_anterior = this.descuento_calculado_auto

        // ⬇️ AGREGAR: Calcular porcentaje automáticamente
        if (this.subtotal > 0) {
          this.desc_venta_porcentaje = (this.descuento * 100) / this.subtotal
        }

        // CALCULAR FECHA LÍMITE
        if (this.tipo_pagoSelect === 2) {
          const config_credito = this.descuentos_aplicables.find(
            (d) => d.config.tipo === 'tipo_pago' && d.config.condicion_tipo_pago_id === 2
          )

          if (config_credito && config_credito.config.dias_plazo) {
            const fecha = new Date()
            fecha.setDate(fecha.getDate() + (this.dias_credito || config_credito.config.dias_plazo))
            this.fecha_limite_descuento = fecha
          }
        }

        this.verificarAdvertenciaDescuento()
        this.agregar_descuento_detalle_productosventas()
        this.calcular_total_venta()
      } catch (error) {
        console.error('Error al calcular descuentos:', error)
      }
    },

    // VERIFICAR SI MOSTRAR ADVERTENCIA
    verificarAdvertenciaDescuento() {
      this.mostrar_advertencia_descuento =
        this.tipo_pagoSelect === 2 && this.descuento > 0 && this.descuentos_aplicables.some((d) => d.config.dias_plazo)
    },

    // FORMATEAR FECHA
    formatearFecha(fecha) {
      if (!fecha) return ''
      return new Date(fecha).toLocaleDateString('es-BO', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      })
    },
    async procesarGuardadoVenta(datos) {
      if (this.guardando) return

      this.guardando = true

      // Mostrar modal simple si está facturando
      if (this.facturar) {
        this.facturando = true
        this.detalleFacturacion =
          'Enviando factura al sistema de impuestos. Por favor no cierre esta ventana ni realice otras acciones hasta que se complete el proceso.'
      }

      try {
        const res = await this.ventaService.crear(datos)

        // Ocultar modal
        this.facturando = false
        this.guardando = false

        // ===== MANEJO DE PROFORMA =====
        if (has(res, 'proforma')) {
          this.$toast.add({
            severity: 'success',
            summary: 'Venta',
            detail: 'Proforma Realizada con Éxito',
            life: 3000
          })
          this.$router.push({
            name: 'proforma_detalle',
            params: { id: res.proforma.id }
          })
          return
        }

        // ===== ERROR DE VALIDACIÓN =====
        if (res.status === 400 || res.status === 422) {
          this.$toast.add({
            severity: 'error',
            summary: 'Error al Procesar la Venta',
            detail: res.message || res.mensaje || 'Error de validación',
            life: 10000
          })
          return
        }

        // ===== TIMEOUT DEL SIN (206) =====
        if (res.status === 206) {
          const ventaId = res.venta?.id

          if (res.puede_reintentar && ventaId && typeof ventaId === 'number') {
            this.mostrarDialogTimeout(ventaId)
          } else if (ventaId) {
            this.$toast.add({
              severity: 'warn',
              summary: 'Venta Sin Factura',
              detail: `Venta #${ventaId} guardada sin factura: ${res.error_detallado}`,
              life: 10000
            })

            setTimeout(() => {
              this.$router.push({
                name: 'venta_detalle',
                params: { id: ventaId }
              })
            }, 2000)
          } else {
            this.$toast.add({
              severity: 'error',
              summary: 'Error Crítico',
              detail: 'No se pudo obtener el ID de la venta',
              life: 10000
            })
          }
          return
        }

        // ===== ÉXITO (200) =====
        if (res.status === 200) {
          this.$toast.add({
            severity: 'success',
            summary: '¡Venta Exitosa!',
            detail: res.mensaje || 'Venta registrada correctamente',
            life: 3000
          })

          setTimeout(() => {
            this.$router.push({
              name: 'venta_detalle',
              params: { id: res.venta.id }
            })
          }, 500)
          return
        }

        // ===== RESPUESTA INESPERADA =====
        this.$toast.add({
          severity: 'warn',
          summary: 'Respuesta Inesperada',
          detail: 'La operación completó con un código no esperado',
          life: 5000
        })
      } catch (error) {
        console.error('Error completo:', error)

        this.facturando = false
        this.guardando = false

        let detalleError = 'No se pudo conectar con el servidor'

        if (error.response) {
          detalleError =
            error.response.data?.message || error.response.data?.mensaje || `Error ${error.response.status}`
        }

        this.$toast.add({
          severity: 'error',
          summary: 'Error de Conexión',
          detail: detalleError,
          life: 10000
        })
      }
    },
    mostrarDialogTimeout(ventaId) {
      if (!ventaId || typeof ventaId !== 'number') {
        console.error('❌ ventaId inválido:', ventaId)
        this.$toast.add({
          severity: 'error',
          summary: 'Error',
          detail: 'No se pudo obtener el ID de la venta',
          life: 5000
        })
        return
      }

      this.$nextTick(() => {
        this.timeoutVentaId = ventaId
        this.timeoutDialogVisible = true
      })
    },

    irADetalleVenta(ventaId) {
      if (!ventaId || ventaId === 0) return

      this.timeoutDialogVisible = false

      this.$router.push({
        name: 'venta_detalle',
        params: { id: ventaId }
      })
    },

    async buscarFacturaTimeout(ventaId) {
      if (!ventaId || ventaId === 0) return

      this.buscandoFactura = true
      this.facturando = true
      this.detalleFacturacion = 'Buscando factura en el SIN. Por favor espere...'

      try {
        const response = await this.ventaService.buscarFacturaTimeout(ventaId)

        this.facturando = false
        this.buscandoFactura = false

        if (response.encontrada) {
          this.$toast.add({
            severity: 'success',
            summary: 'Factura Encontrada',
            detail: response.mensaje || 'La factura fue generada correctamente',
            life: 5000
          })

          this.timeoutDialogVisible = false

          setTimeout(() => {
            this.$router.push({
              name: 'venta_detalle',
              params: { id: ventaId }
            })
          }, 1000)
        } else {
          this.$toast.add({
            severity: 'warn',
            summary: 'Factura No Encontrada',
            detail: response.mensaje || 'No se encontró la factura en el SIN. Intenta nuevamente en unos minutos.',
            life: 8000
          })
        }
      } catch (error) {
        console.error('Error al buscar factura:', error)

        this.facturando = false
        this.buscandoFactura = false

        this.$toast.add({
          severity: 'error',
          summary: 'Error de Conexión',
          detail: 'No se pudo conectar con el servidor. Intenta nuevamente.',
          life: 8000
        })
      }
    },

    async cargarClienteFactura(response) {
      const cliente_factura = response?.cliente_factura || response

      if (!cliente_factura || !cliente_factura.ci_nit) {
        return
      }

      this.cargandoNit = false

      this.nitClientesFiltrados = []

      const nitValue = cliente_factura.ci_nit
      const nombreValue = cliente_factura.nombre

      this.nit = nitValue
      this.razon_social = nombreValue
      this.nitClienteSelect = nitValue
    },
    // Permitir solo números
    soloNumeros(event) {
      const char = String.fromCharCode(event.keyCode)
      if (!/[0-9]/.test(char)) {
        event.preventDefault()
      }
    },

    // Validar y limitar a 8 dígitos
    validarTarjetaInput() {
      if (this.nro_tarjeta) {
        this.nro_tarjeta = this.nro_tarjeta.replace(/\D/g, '')

        if (this.nro_tarjeta.length > 8) {
          this.nro_tarjeta = this.nro_tarjeta.substring(0, 8)
        }
      }
    },

    // Validar antes de guardar
    verificarMetodoPago() {
      if (this.metodo_pagoSelect === 2 && this.facturar === true) {
        if (!this.nro_tarjeta || this.nro_tarjeta.trim() === '') {
          this.$toast.add({
            severity: 'error',
            summary: 'Número de Tarjeta Requerido',
            detail: 'Debe ingresar el número de tarjeta de 8 dígitos',
            life: 5000
          })
          return true
        }

        if (this.nro_tarjeta.length !== 8) {
          this.$toast.add({
            severity: 'error',
            summary: 'Número de Tarjeta Inválido',
            detail: `Debe tener exactamente 8 dígitos. Tiene: ${this.nro_tarjeta.length}`,
            life: 5000
          })
          return true
        }

        if (!/^\d{8}$/.test(this.nro_tarjeta)) {
          this.$toast.add({
            severity: 'error',
            summary: 'Número de Tarjeta Inválido',
            detail: 'El número de tarjeta debe contener solo dígitos',
            life: 5000
          })
          return true
        }
      }

      return false
    },

    async buscarClientePorNitImpl(texto, cacheKey) {
      this.cargandoNit = true

      try {
        const response = await this.clienteService.buscarClientesNitOptimizado({
          texto: texto,
          limite: 20
        })

        const data = response.data || response

        if (data.status === 200 && data.success && data.clientes?.length > 0) {
          this.nitClientesFiltrados = data.clientes

          // Guardar en caché si existe
          if (this.cacheBusquedaNit) {
            this.cacheBusquedaNit.set(cacheKey, data.clientes)

            // Limpiar caché viejo
            if (this.cacheBusquedaNit.size > 20) {
              const firstKey = this.cacheBusquedaNit.keys().next().value
              this.cacheBusquedaNit.delete(firstKey)
            }
          }
        } else if (data.status === 404) {
          this.nitClientesFiltrados = []
        }
      } catch (error) {
        console.error('Error buscando cliente:', error)
        this.nitClientesFiltrados = []
        this.$toast.add({
          severity: 'error',
          summary: 'Error de Búsqueda',
          detail: 'No se pudo realizar la búsqueda',
          life: 5000
        })
      } finally {
        this.cargandoNit = false
      }
    },
    async buscarClientePorNitConEnter() {
      if (!this.nitClienteSelect || this.nitClienteSelect.length < 3) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Búsqueda',
          detail: 'Ingrese al menos 3 caracteres',
          life: 3000
        })
        return
      }

      this.cargandoNit = true

      try {
        const texto = this.nitClienteSelect.trim()

        // SIEMPRE hacer búsqueda en el servidor (sin usar caché)
        const response = await this.clienteService.buscarClientesNitOptimizado({
          texto: texto,
          limite: 20
        })

        const data = response.data || response

        if (data.status === 200 && data.success && data.clientes?.length > 0) {
          this.nitClientesFiltrados = data.clientes

          // Guardar en caché para el AutoComplete
          const cacheKey = `nit_${texto.toLowerCase()}`
          if (this.cacheBusquedaNit) {
            this.cacheBusquedaNit.set(cacheKey, data.clientes)

            if (this.cacheBusquedaNit.size > 20) {
              const firstKey = this.cacheBusquedaNit.keys().next().value
              this.cacheBusquedaNit.delete(firstKey)
            }
          }
        } else {
          this.nitClientesFiltrados = []
          this.$toast.add({
            severity: 'info',
            summary: 'Sin resultados',
            detail: data.mensaje || 'No se encontraron clientes',
            life: 6000
          })
        }
      } catch (error) {
        console.error('Error buscando cliente por NIT:', error)
        this.$toast.add({
          severity: 'error',
          summary: 'Error de Búsqueda',
          detail: 'No se pudo realizar la búsqueda',
          life: 5000
        })
        this.nitClientesFiltrados = []
      } finally {
        this.cargandoNit = false
      }
    },
    async seleccionarClienteNit(event) {
      const clienteSeleccionado = event.value

      if (!clienteSeleccionado) return

      // Asignamos valores a la vista
      this.nit = clienteSeleccionado.ci_nit
      this.razon_social = clienteSeleccionado.nombre
      this.nitClienteSelect = clienteSeleccionado.ci_nit
    },

    obtenerNombreTipoDocumento(tipo) {
      const tipos = {
        1: 'CI',
        2: 'CEX',
        3: 'PAS',
        4: 'OD',
        5: 'NIT'
      }
      return tipos[tipo] || 'DOC'
    },

    //BUSCAR PRODUCTOS
    async buscarProductoImpl(texto, cacheKey) {
      try {
        const response = await this.productService.buscarProductosOptimizado({
          texto: texto,
          buscarProductoPorSelected: this.buscarProductoPorSelected,
          sucursal_id: this.sucursal_id
        })

        if (response && response.productos) {
          this.productosListadoFiltrado = [...response.productos]
          this.cacheBusquedaProducto.set(cacheKey, response.productos)

          if (this.cacheBusquedaProducto.size > 30) {
            const firstKey = this.cacheBusquedaProducto.keys().next().value
            this.cacheBusquedaProducto.delete(firstKey)
          }
        } else {
          this.productosListadoFiltrado = []
        }
      } catch (error) {
        console.error('Error buscando producto:', error)
        this.$toast.add({
          severity: 'error',
          summary: 'Error de Búsqueda',
          detail: 'No se pudieron cargar los productos',
          life: 3000
        })
        this.productosListadoFiltrado = []
      }
    },

    async buscarClienteImpl(texto, cacheKey) {
      this.cargandoCliente = true

      try {
        const response = await this.clienteService.buscarClientesOptimizado({
          texto: texto,
          limite: 20
        })

        const data = response.data || response

        if (data.status === 200 && data.success && data.clientes && data.clientes.length > 0) {
          // Asegurar que todos los clientes tengan los campos necesarios
          this.clientes = data.clientes.map((cliente) => ({
            ...cliente,
            tipo_cliente_id: cliente.tipo_cliente_id || 1,
            nombre_tipo_cliente: cliente.nombre_tipo_cliente || 'NORMAL'
          }))

          // Guardar en caché
          this.cacheBusquedaCliente.set(cacheKey, this.clientes)

          // Limpiar caché viejo
          if (this.cacheBusquedaCliente.size > 20) {
            const firstKey = this.cacheBusquedaCliente.keys().next().value
            this.cacheBusquedaCliente.delete(firstKey)
          }
        } else if (data.status === 404) {
          this.clientes = []

          this.$toast.add({
            severity: 'warn',
            summary: 'Sin Resultados',
            detail: data.mensaje || `No se encontró ningún paciente con "${texto}"`,
            life: 4000
          })
        } else {
          this.clientes = []

          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: data.mensaje || 'Error en la búsqueda',
            life: 5000
          })
        }
      } catch (error) {
        console.error('Error buscando paciente:', error)

        this.clientes = []

        this.$toast.add({
          severity: 'error',
          summary: 'Error de Búsqueda',
          detail: 'No se pudo realizar la búsqueda',
          life: 5000
        })
      } finally {
        this.cargandoCliente = false
      }
    },

    //  ACTUALIZAR - AutoComplete con caché
    buscarClienteAutoComplete(event) {
      const texto = event.query?.trim()

      if (!texto || texto.length < 1) {
        this.clientes = []
        return
      }

      const cacheKey = `cliente_${texto.toLowerCase()}`
      if (this.cacheBusquedaCliente.has(cacheKey)) {
        this.clientes = this.cacheBusquedaCliente.get(cacheKey)
        return
      }

      this.buscarClienteDebounced(texto, cacheKey)
    },

    // ACTUALIZAR - Agregar cliente nuevo sin recargar todo
    cargarClientesListado(clienteNuevo = null) {
      if (clienteNuevo && clienteNuevo.id) {
        const cliente = {
          ...clienteNuevo,
          tipo_cliente_id: clienteNuevo.tipo_cliente_id || 1,
          nombre_tipo_cliente: clienteNuevo.nombre_tipo_cliente || 'NORMAL'
        }

        const indice = this.clientes.findIndex((c) => c.id === cliente.id)

        if (indice === -1) {
          this.clientes.unshift(cliente)
        } else {
          this.clientes.splice(indice, 1, cliente)
        }

        this.clienteSelect = cliente
        this.cacheBusquedaCliente.clear()

        return
      }

      this.clienteService
        .getClientesAll()
        .then((response) => {
          this.clientes = response.map((cliente) => ({
            ...cliente,
            tipo_cliente_id: cliente.tipo_cliente_id || 1,
            nombre_tipo_cliente: cliente.nombre_tipo_cliente || 'NORMAL'
          }))

          if (!this.clienteSelect && this.clientes.length > 0) {
            this.clienteSelect = this.clientes[0]
          }
        })
        .catch((error) => console.log(error))
    },

    // ACTUALIZAR - Búsqueda de NIT solo con ENTER (sin botón)
    buscarClientePorNit() {
      if (!this.nit || this.nit == 0) return

      this.clienteService.buscarClientePorNit({ nit: this.nit, sucursal_id: this.sucursal_id }).then((response) => {
        if (response.cliente != null) {
          this.$toast.add({
            severity: 'success',
            summary: 'NIT encontrado',
            detail: 'Se cargaron los datos del cliente',
            life: 3000
          })
          let nombre_cliente = response.cliente.nombre_cliente ?? response.cliente
          this.razon_social = nombre_cliente ?? ''
        } else {
          this.$toast.add({
            severity: 'warn',
            summary: 'NIT no encontrado',
            detail: 'Puede registrar los datos del cliente',
            life: 3000
          })
          this.razon_social = ''
          this.activarClienteFactura()
        }
      })
    },

    buscarProducto() {
      if (!this.clienteSelect || !this.clienteSelect.id) {
        this.$toast.add({
          severity: 'warn',
          summary: 'Seleccione Cliente',
          detail: 'Debe seleccionar un cliente primero',
          life: 3000
        })
        return
      }

      if (this.cargandoProductoBusqueda) {
        return
      }

      if (
        !this.productoSelecionado ||
        typeof this.productoSelecionado !== 'string' ||
        this.productoSelecionado.trim().length < 2
      ) {
        return
      }

      let datos = {
        texto: this.productoSelecionado,
        buscarProductoPorSelected: this.buscarProductoPorSelected,
        sucursal_id: this.sucursal_id,
        tipo_cliente_id: this.clienteSelect.tipo_cliente_id || 1
      }

      this.cargandoProductoBusqueda = true

      this.productService
        .buscarXNombreVenta(datos)
        .then((response) => {
          if (response.productos.length == 0) {
            this.$toast.add({
              severity: 'error',
              summary: 'Error',
              detail: 'No se encontraron productos',
              life: 3000
            })
            this.productosListadoFiltrado = []
            return
          }

          this.productosListadoFiltrado = [...response.productos]
          this.productosListadoFiltrado.sort((a, b) => {
            if (a.stock[0].cantidad < b.stock[0].cantidad) return 1
            if (a.stock[0].cantidad > b.stock[0].cantidad) return -1
            return 0
          })
        })
        .catch((error) => {
          console.log(error)
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Error al buscar productos',
            life: 3000
          })
        })
        .finally(() => {
          this.cargandoProductoBusqueda = false
        })
    },

    // Limpiar cachés
    limpiarCaches() {
      this.cacheBusquedaProducto.clear()
      this.cacheBusquedaNit.clear()
      this.cacheBusquedaCliente.clear()
    },

    cancelarQR() {
      let datos = {
        qrId: this.qrId
      }
      this.cancelando_qr = true
      this.ventaService.cancelarQR(datos).then((response) => {
        if (response.status == 200) {
          this.qrImage = null
          this.qrId = null
          this.generar_qr = false
          this.cancelando_qr = false
          this.$toast.add({
            severity: 'success',
            summary: 'QR Cancelado',
            detail: response.message,
            life: 3000
          })
        } else {
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: response.message,
            life: 3000
          })
          this.cancelando_qr = false
        }
      })
    },

    verificarEstadoQR() {
      if (this.qrImage) {
        let datos = {
          qrId: this.qrId,
          correo_para: null
        }
        this.ventaService.verificarEstadoQR(datos).then((response) => {
          console.log(response)
          this.estado_qr_generado = response.estado_qr_generado
          if (response.estado_qr_generado == 1) {
            this.$toast.add({
              severity: 'success',
              summary: 'QR Pagado',
              detail: response.message,
              life: 6000
            })
            this.detenerVerificacion()
          } else if (response.estado_qr_generado == 9) {
            this.$toast.add({
              severity: 'error',
              summary: 'QR Anulado',
              detail: response.message,
              life: 6000
            })
            this.detenerVerificacion()
          } else {
            console.log('QR Pendiente de Pago')
          }
        })
      }
    },

    generarQR() {
      let datos = {
        monto: this.monto_pago
      }
      this.generando_qr = true
      this.ventaService.generarQR(datos).then((response) => {
        if (response.status == 200) {
          this.qrImage = response.qrImage
          this.qrId = response.qrId
          this.generar_qr = true
          this.generando_qr = false
          this.iniciarVerificacion()
        } else {
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: response.message,
            life: 3000
          })
          this.generando_qr = false
        }
      })
    },

    iniciarVerificacion() {
      this.verificarQRInterval = setInterval(() => {
        this.verificarEstadoQR()
      }, 10000)
    },

    detenerVerificacion() {
      if (this.verificarQRInterval) {
        clearInterval(this.verificarQRInterval)
        this.verificarQRInterval = null
      }
    },

    agregarProductosVendidos(productos) {
      productos.forEach((producto) => {
        try {
          let precio_sugerido = parseFloat(producto.pivot.precio ?? 0)
          this.agregarDetalleVenta({
            ...producto,
            cantidad: producto.stock_actual,
            producto_id: producto.id,
            nombre_producto: producto.descripcion,
            cantidad_venta: parseFloat(producto.pivot.cantidad),
            descuento_neto: parseFloat(producto.pivot.descuento_neto),
            descuento_porcentaje: parseFloat(producto.pivot.descuento_porcentaje),
            ultimo_precio: precio_sugerido,
            precio_sugerido: precio_sugerido,
            total: precio_sugerido * producto.pivot.cantidad,
            lote: producto.pivot.lote ?? null,
            fecha_vence: producto.pivot.fecha_vence ?? null
          })
        } catch (error) {
          console.log(error)
        }
      })
    },

    soloPrimeraPalabra(texto) {
      if (texto) {
        return texto.split(' ')[0]
      } else {
        return 'UNIDAD'
      }
    },

    formatDate(fecha) {
      if (fecha) {
        return fecha.split('-').reverse().join('/')
      }
      return ''
    },

    verificarCasoUso() {
      if (this.buscarProductoPorSelected.includes('principio_activo')) {
        return true
      } else {
        return false
      }
    },

    actualizarPanelMasFiltros(e) {
      this.masFiltrosBusqueda = e
      if (!this.masFiltrosBusqueda) {
        this.limpiarFiltrosBusquedaProducto()
      }
    },

    limpiarFiltrosBusquedaProducto() {
      this.buscarProductoPorSelected = ['nombre_comercial']
    },

    cambiarActividadEconomica() {
      let datos = {
        actividad_economica_id: this.actividad_economica_selected
      }
      this.empresaService.changeActividad(datos).then((data) => {
        if (data.status == 200) {
          this.$toast.add({
            severity: 'success',
            summary: 'ACTIVIDAD ECONOMICA',
            detail: data.message,
            life: 3000
          })
        } else {
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: 'Error al cambiar la actividad economica',
            life: 3000
          })
        }
      })
    },

    calcular_agregar_des_total_venta() {
      this.calcular_descuento_venta_porcentaje()
      this.agregar_descuento_detalle_productosventas()
      this.calcular_total_venta()
    },

    calcular_agregar_des_total_venta_porcentaje() {
      this.calcular_descuento_venta_neto()
      this.agregar_descuento_detalle_productosventas()
      this.calcular_total_venta()
    },

    cerrarModalProductoResultados() {
      this.productosResultados = false
    },

    activarModalProductosFiltrados() {
      this.productosResultados = true
      this.productosFiltrados = this.productosListadoFiltrado.map((producto) => {
        return {
          ...producto,
          tipo_cliente_id: this.clienteSelect?.tipo_cliente_id || 1
        }
      })
    },

    datos_venta_general() {
      let datos = {
        verificar_caja: true,
        facturar: 'facturar'
      }
      this.ventaService.VentaGeneral(datos).then((response) => {
        if (response.success) {
          if (response.datos.caja.length == 0) {
            this.$toast.add({
              severity: 'error',
              summary: 'Error',
              detail: 'No se encontró una caja abierta'
            })
            this.permitirVenta = false
            this.cargandoComponente = true
            return
          }

          this.caja = response.datos.caja[0]
          this.sucursal_id = response.datos.caja[0].sucursal_id
          this.punto_venta_id = response.datos.caja[0].punto_venta_id
          this.codigo_punto_venta = response.datos.caja[0].codigo_punto_venta

          this.qr_cobros = response.datos.qr_cobros
          this.nombre_sucursal = response.datos.caja[0].nombre_sucursal ?? ''
          this.permitirVenta = true

          this.clientes = response.datos.clientes.map((cliente) => ({
            ...cliente,
            tipo_cliente_id: cliente.tipo_cliente_id || 1,
            nombre_tipo_cliente: cliente.nombre_tipo_cliente || 'NORMAL'
          }))

          this.clienteSelect = this.clientes.length ? this.clientes[0] : null
          this.tipo_pagos = response.datos.tipo_pagos
          this.metodo_pagos = response.datos.metodo_pagos
          this.paqueteproductos = response.datos.paquetes
          this.medicos = response.datos.medicos
          this.laboratorios = response.datos.laboratorios

          if (response.datos.facturar) {
            this.permitir_facturar = true
          } else {
            this.permitir_facturar = false
          }

          this.actividades_economicas = response.datos.actividades_economicas || []
          if (this.actividades_economicas.length) {
            this.actividad_economica_selected = response.datos.actividad_economica_select.codigo
          }

          this.parametros_sistema = response.datos.parametros_sistema ?? {}
          if (this.parametros_sistema.length > 0) {
            this.imprimirFactura = this.parametros_sistema.some((parametro) => parametro.nombre === 'Imprimir Factura')
            this.imprimirVenta = this.parametros_sistema.some((parametro) => parametro.nombre === 'Imprimir Venta')
            this.permisoActivarModalProductos = this.parametros_sistema.some(
              (parametro) => parametro.nombre === 'permisoActivarModalProductos'
            )
            this.mostrarFechaEnDetalle = this.parametros_sistema.some(
              (parametro) => parametro.nombre === 'mostrarFechaEnDetalle'
            )
            this.permitir_pago_qr_banco = this.parametros_sistema.some(
              (parametro) => parametro.nombre === 'permitir_pago_qr_banco'
            )
            this.descuentos_configurables = this.parametros_sistema.some(
              (parametro) => parametro.nombre === 'descuentos_configurables'
            )
          }
        } else {
          this.$toast.add({
            severity: 'error',
            summary: 'Error',
            detail: response.message,
            life: 60000
          })
        }

        this.cargandoComponente = true
      })
    },

    verificarFacturar() {
      this.parametrosSistemaService.verificarPermiso('facturar').then((response) => {
        if (response.permiso) {
          this.permitir_facturar = true
        } else {
          this.permitir_facturar = false
        }
      })
    },

    obtenerPaquetes() {
      this.paqueteProductoService.getPaqueteProductoAll().then((response) => {
        this.paqueteproductos = response.paqueteproductos
      })
    },

    obtenerTiposPagos() {
      this.tipoPagoService.getAllTipoPagos().then((response) => {
        this.tipo_pagos = response.tipo_pagos
      })
    },

    obtenerMetodosPagos() {
      this.metodoPagoService.getAllMetodoPagos().then((response) => {
        this.metodo_pagos = response.metodo_pagos
      })
    },

    aplicar_descuento_productos_detalle() {
      this.productosVentas.forEach((producto) => {
        producto.descuento_porcentaje = this.desc_venta_porcentaje
        producto.descuento_neto =
          producto.ultimo_precio * producto.cantidad_venta * (producto.descuento_porcentaje / 100)
      })
      this.calcular_subtotal()
    },

    buscarCliente(event) {
      setTimeout(() => {
        this.clienteService.buscarXNombre({ texto: event.query }).then((response) => {
          if (response.clientes.length == 0) {
            this.$toast.add({
              severity: 'info',
              summary: 'Cliente no encontrado',
              detail: 'Puede registrar un nuevo cliente',
              life: 6000
            })
          }
          this.clientes = [...response.clientes]
        })
      }, 250)
    },

    verificarCajaAbierta() {
      this.cajaService.verificarCajaAbierta().then((response) => {
        if (response.caja.length > 0) {
          this.caja = response.caja[0]
          this.sucursal_id = response.caja[0].sucursal_id
          this.permitirVenta = true
        } else {
          this.permitirVenta = false
        }

        this.cargandoComponente = true
      })
    },

    convertirNumeroGermanicFormat(numero) {
      return new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(numero)
    },

    sinDecimal(numero) {
      return new Intl.NumberFormat('de-DE', {
        minimumFractionDigits: 0,
        maximumFractionDigits: 0
      }).format(numero)
    },

    verificarMedico() {
      if (this.medico_referencia == true && this.medicoSelected == null) {
        this.$toast.add({
          severity: 'error',
          summary: 'MÉDICO',
          detail: 'DEBE SELECCIONAR UN MÉDICO',
          life: 10000
        })
        return true
      }
      return false
    },
    verificarCliente() {
      if (!this.clienteSelect || this.clienteSelect.id == null) {
        this.$toast.add({
          severity: 'error',
          summary: 'CLIENTE',
          detail: 'DEBE SELECCIONAR UN CLIENTE',
          life: 10000
        })
        return true
      }
      return false
    },

    verificarDatosFactura() {
      if (this.facturar === true && (!this.nit || this.nit.toString().trim() === '')) {
        console.error('❌ Validación falló - facturar:', this.facturar, 'nit:', this.nit)
        this.$toast.add({
          severity: 'error',
          summary: 'NIT',
          detail: 'DEBE INGRESAR EL NIT',
          life: 10000
        })
        return true
      }
      return false
    },

    guardarVenta() {
      if (
        this.verificarMedico() ||
        this.verificarCliente() ||
        this.verificarMetodoPago() ||
        this.verificarDatosFactura()
      ) {
        return
      }

      let productos = this.productosVentas.filter(
        (producto) => producto.cantidad_venta == 0 || producto.cantidad_venta == null
      )
      if (productos.length > 0) {
        this.$toast.add({
          severity: 'error',
          summary: 'Revisar productos con cantidad de venta en 0',
          detail: 'No puede guardar una venta con productos con cantidad de venta en 0',
          life: 60000
        })
        this.guardando = false
        return
      }

      let datos = {
        razon_social: this.razon_social,
        nit: this.nit,
        cliente_id: this.clienteSelect.id,
        total_cancelar: this.total_venta,
        descuento: this.descuento ? this.descuento : 0,
        efectivo: this.efectivo ? this.efectivo : 0,
        productos: this.productosVentas,
        caja_id: this.caja.id,
        tipo_pago_id: this.tipo_pagoSelect,
        metodo_pago_id: this.metodo_pagoSelect,
        monto_pago: this.monto_pago ? this.monto_pago : 0,
        dias_credito: this.dias_credito,
        a_cuenta: this.a_cuenta ? this.a_cuenta : 0,
        cambio: this.cambio,
        facturado: this.facturar ? 1 : 0,
        observacion: this.observacion,
        nombre_paquete: this.paqueteSelected ? this.paqueteSelected : null,
        nro_tarjeta: this.nro_tarjeta ? this.nro_tarjeta : null,
        proforma: this.proforma,
        proforma_id: this.proforma_id,
        sucursal_id: this.sucursal_id,
        punto_venta_id: this.punto_venta_id,
        nombre_medico: this.medicoSelected
          ? this.medicos.find((medico) => medico.id === this.medicoSelected)?.nombre_completo ?? null
          : null,
        codigo_punto_venta: this.codigo_punto_venta,
        nombre_cliente: this.clienteSelect || this.clienteSelect.id ? this.clienteSelect.nombre : null,
        descuentos_aplicables:
          this.descuentos_configurables && this.descuentos_aplicables.length > 0 ? this.descuentos_aplicables : null
      }

      if (this.medico_referencia == 'medico_referencia') {
        datos = { ...datos, medico_id: this.medicoSelected }
      }

      let texto_mensaje_confirmacion = this.proforma
        ? '¿ESTÁS SEGURO DE GUARDAR LA PROFORMA?'
        : this.facturar
        ? '¿ESTÁS SEGURO DE GUARDAR LA FACTURA?'
        : '¿ESTÁS SEGURO DE GUARDAR LA VENTA?'

      if (this.productosVentas.length > 0) {
        this.$confirm.require({
          header: 'CONFIRMACIÓN',
          message: texto_mensaje_confirmacion,
          icon: 'pi pi-exclamation-triangle',
          acceptLabel: 'REGISTRAR',
          rejectLabel: 'CANCELAR',
          acceptClass: 'p-button-primary p-button-lg',
          rejectClass: 'p-button-danger p-button-lg',
          acceptIcon: 'pi pi-save',
          rejectIcon: 'pi pi-times',
          closable: false,
          closeOnEscape: false,
          accept: () => {
            this.procesarGuardadoVenta(datos)
          },
          reject: () => {
            this.$toast.add({
              severity: 'info',
              summary: 'Venta',
              detail: 'Venta Cancelada',
              life: 3000
            })
            this.guardando = false
          }
        })
      }
    },

    activarCliente() {
      this.clienteModal = true
      this.cliente = {
        estado: { label: 'Activo', value: 1 },
        nombre: this.clienteSelect?.nombre ?? this.clienteSelect
      }
    },

    activarClienteFactura() {
      const textoEscrito = this.nitClienteSelect?.trim() || ''
      const esNumerico = /^\d+$/.test(textoEscrito)

      this.cliente_factura = {
        estado: { label: 'Activo', value: 1 },
        ci_nit: esNumerico ? textoEscrito : '',
        nombre: !esNumerico ? textoEscrito : '', //
        tipo_documento: esNumerico ? (textoEscrito.length >= 9 ? 5 : 1) : 1
      }

      this.clienteFacturaModal = true
    },
    cerrarModalClienteFactura() {
      this.clienteFacturaModal = false
    },

    cerrarModalCliente() {
      this.clienteModal = false
      this.cliente = {}
    },

    guardandoCambiosCelda(e) {
      let { data, newValue, field } = e
      data[field] = newValue
      if (field == 'cantidad_venta') {
        if (data.cantidad_venta > data.cantidad) {
          data.cantidad_venta = null
          this.$toast.add({
            severity: 'error',
            summary: 'REVISAR STOCK DE PRODUCTO',
            detail: 'No hay suficiente stock: ' + data.nombre_producto,
            life: 60000
          })
        } else {
          data['total'] = data['cantidad_venta'] * data['ultimo_precio']
          this.calcular_subtotal()
          if (this.aplica_descuento) {
            this.calcular_agregar_des_total_venta_porcentaje()
          }
        }
      }
      if (field == 'ultimo_precio' && data['cantidad_venta'] > 0) {
        data['ultimo_precio'] = data['ultimo_precio'] ?? 0
        data['total'] = data['cantidad_venta'] * data['ultimo_precio']
        this.calcular_subtotal()
        if (this.aplica_descuento == 'aplica_descuento') {
          this.calcular_agregar_des_total_venta_porcentaje()
        }
      }
      if (field == 'descuento_neto' && data['cantidad_venta'] > 0) {
        if (newValue > data['total']) {
          data['descuento_neto'] = data['total']
          data['descuento_porcentaje'] = (data['descuento_neto'] * 100) / data['total']
          this.calcular_descuentos_totales_venta()
          this.$toast.add({
            severity: 'error',
            summary: 'REVISAR DESCUENTO',
            detail: 'El descuento no puede ser mayor al total',
            life: 60000
          })
          return
        }
        data['descuento_porcentaje'] = (newValue * 100) / data['total']
        this.calcular_descuentos_totales_venta()
      }
      if (field == 'descuento_porcentaje' && data['cantidad_venta'] > 0) {
        data['descuento_neto'] = (newValue * data['total']) / 100
        this.calcular_descuentos_totales_venta()
      }
    },

    calcular_descuentos_totales_venta() {
      let desc_venta_neto = 0
      this.productosVentas.forEach((producto) => {
        desc_venta_neto += producto.descuento_neto
      })
      this.descuento = desc_venta_neto
      this.desc_venta_porcentaje = (this.descuento * 100) / this.subtotal
      this.calcular_total_venta()
    },

    calcular_subtotal() {
      this.subtotal = 0
      this.productosVentas.forEach((product) => {
        this.subtotal += product.total
      })
      this.total_venta = this.subtotal - this.descuento
      if (this.descuento >= 0) {
        this.agregar_descuento_detalle_productosventas()
      }
    },

    agregar_descuento_detalle_productosventas() {
      this.productosVentas.forEach((producto) => {
        producto.descuento_neto = (this.descuento * producto.total) / this.subtotal
        producto.descuento_porcentaje = (producto.descuento_neto * 100) / producto.total
      })
    },

    calcular_total_venta() {
      this.total_venta = this.subtotal - this.descuento
    },

    calcular_descuento_venta_porcentaje() {
      this.desc_venta_porcentaje = (this.descuento * 100) / this.subtotal
    },

    calcular_descuento_venta_neto() {
      this.descuento = (this.desc_venta_porcentaje * this.subtotal) / 100
    },

    quitarProductoDetalle(datos) {
      this.$confirm.require({
        header: 'Confirmación',
        icon: 'pi pi-exclamation-triangle',
        message: '¿ESTÁS SEGURO DE ELIMINAR EL PRODUCTO?',
        acceptLabel: 'Si, Eliminar',
        rejectLabel: 'No, Cancelar',
        acceptClass: 'p-button-primary p-button-lg',
        rejectClass: 'p-button-danger p-button-lg',
        acceptIcon: 'pi pi-save',
        rejectIcon: 'pi pi-times',
        accept: () => {
          this.productosVentas.splice(datos.index, 1)
          this.calcular_subtotal()
          this.calcular_agregar_des_total_venta_porcentaje()
        }
      })
    },

    buscarCodProducto() {
      const datos = {
        texto: this.codProdSelected
      }
      this.productService
        .buscarXCodProducto(datos)
        .then((response) => {
          let product = response.productos[0]
          console.log(product)
          this.codProdSelected = null
          this.codProdListadoFiltrado = []
        })
        .catch((error) => console.error(error))
    },

    agregarDetalleVenta(data) {
      if (this.productosVentas.length > 0) {
        let existe = this.productosVentas.find((producto) => producto.id == data.id)
        if (existe) {
          this.$toast.add({
            severity: 'info',
            summary: 'Venta',
            detail: 'El producto ya se encuentra en la venta',
            life: 60000
          })
          return
        }
      }
      if (data.ultimo_precio == 0 || data.precio_sugerido == 0) {
        this.$toast.add({
          severity: 'info',
          summary: 'Venta',
          detail: 'El producto no tiene un precio asignado: ' + data.nombre_producto,
          life: 60000
        })
        return
      }
      if (data.ultimo_precio_compra == 0) {
        this.$toast.add({
          severity: 'info',
          summary: 'Venta',
          detail: 'El producto no tiene un precio de compra asignado: ' + data.nombre_producto,
          life: 60000
        })
        return
      }

      let precio = data.ultimo_precio == 0 ? data.precio_sugerido : data.ultimo_precio
      this.productosVentas.push({
        cantidad_venta: 1,
        descuento_neto: 0,
        descuento_porcentaje: 0,
        ...data,
        ultimo_precio: precio,
        total: precio * data.cantidad_venta,
        fecha_vence: data.fecha_vence ?? null,
        lote: data.lote ?? null
      })

      if (data.cantidad == 0) {
        this.$toast.add({
          severity: 'info',
          summary: 'Venta',
          detail: 'El producto no tiene stock: ' + data.nombre_producto + ' ',
          life: 60000
        })
        this.productosVentas.pop()
        this.productoSelecionado = null
        this.codProdSelected = null
        return
      }

      this.stockSucursales = []
      this.fechas_vencimiento = []
      this.productosListadoFiltrado = []
      this.productoSelecionado = null
      this.codProdSelected = null

      this.calcular_subtotal()
    },

    agregarProductos(productosSeleccionados) {
      productosSeleccionados.forEach((producto) => {
        try {
          if (producto.stock == null || producto.stock == '' || producto.stock == 0) {
            this.$toast.add({
              severity: 'info',
              summary: 'VENTA/STOCK',
              detail: 'El producto: ' + producto.descripcion + ' no tiene stock',
              life: 60000
            })
            return
          }

          let precio_sugerido = this.obtenerPrecioSugerido2(producto, this.clienteSelect?.tipo_cliente_id || 1)
          this.agregarDetalleVenta({
            ...producto,
            cantidad: producto.stock[0].cantidad,
            producto_id: producto.id,
            sucursal_id: producto.stock[0].sucursal_id,
            nombre_producto: producto.descripcion,
            cantidad_venta: 1,
            descuento_neto: 0,
            descuento_porcentaje: 0,
            ultimo_precio: precio_sugerido,
            precio_sugerido: precio_sugerido,
            total: precio_sugerido * 1,
            lote: producto.fechas_vencimiento[0].lote ?? null,
            fecha_vence: producto.fechas_vencimiento[0].fecha_vence ?? null
          })
        } catch (error) {
          console.log(error)
        }
      })
      this.cerrarModalProductoResultados()
    },

    agregarProductosPaqueteAlDetalle() {
      let datos = {
        paquete_producto_id: this.paqueteSelected
      }
      this.paqueteProductoService
        .getPaqueteProductoById(datos)
        .then((response) => {
          response.paqueteproductosListado.forEach((producto) => {
            let paquete_cantidad = producto.cantidad
            let precio =
              producto.stock_para_caja_activa == null
                ? producto.producto.precio_sugerido
                : producto.stock_para_caja_activa.ultimo_precio
            if (producto.stock_para_caja_activa.cantidad < paquete_cantidad) {
              this.$toast.add({
                severity: 'error',
                summary: 'Revisar stock del producto',
                detail: 'El producto no tiene stock suficiente: ' + producto.producto.descripcion,
                life: 60000
              })
              return
            }
            this.agregarDetalleVenta({
              ...producto,
              id: producto.producto_id,
              cantidad: producto.stock_actual,
              sucursal_id: producto.sucursal_id,
              cantidad_venta: paquete_cantidad,
              descuento_neto: 0,
              descuento_porcentaje: 0,
              ultimo_precio: parseFloat(precio),
              precio_sugerido: parseFloat(producto.producto.precio_sugerido),
              total: parseFloat(precio * producto.cantidad),
              lote: producto.stock_para_caja_activa.lote ?? null,
              fecha_vence: producto.stock_para_caja_activa.fecha_vence ?? null
            })

            this.calcular_subtotal()
          })
        })
        .catch((error) => console.log(error))
    },

    agregarProductosProforma() {
      let datos = {
        proforma_codigo: this.proforma_codigo
      }
      this.ventaService.buscarProforma(datos).then((response) => {
        if (response.proforma != null) {
          this.proforma_id = response.proforma.id
          let datos_cliente = {
            nombre_tipo_cliente: response.proforma.nombre_tipo_cliente,
            ci_nit: response.proforma.ci_nit,
            razon_social: response.proforma.cliente,
            cliente_id: response.proforma.cliente_id,
            nombre: response.proforma.cliente,
            id: response.proforma.cliente_id,
            tipo_cliente_id: response.proforma.tipo_cliente_id || 1
          }
          this.clienteSelect = datos_cliente

          response.proforma.detalles.forEach((producto) => {
            let cantidad_proforma = producto.pivot.cantidad
            let precio = producto.pivot.precio
            this.agregarDetalleVenta({
              ...producto,
              id: producto.pivot.producto_id,
              producto_id: producto.pivot.producto_id,
              nombre_producto: producto.descripcion,
              cantidad: producto.stock_actual_new,
              cantidad_venta: producto.pivot.cantidad,
              descuento_neto: 0,
              descuento_porcentaje: 0,
              ultimo_precio: parseFloat(precio),
              precio_sugerido: parseFloat(producto.precio),
              total: parseFloat(precio * cantidad_proforma),
              lote: producto.pivot.lote ?? null,
              fecha_vence: producto.pivot.fecha_vence ?? null
            })
          })
        } else {
          this.$toast.add({
            severity: 'error',
            summary: 'Proforma',
            detail: 'No se encontro la proforma',
            life: 60000
          })
        }
      })
    },

    obtenerPrecioSugerido(producto, tipo_cliente_id) {
      let precio_sugerido = producto.ultimo_precio == 0 ? producto.precio_sugerido : producto.ultimo_precio
      if (tipo_cliente_id == 2) {
        precio_sugerido = producto.pv2 > 0 ? producto.pv2 : precio_sugerido
      } else if (tipo_cliente_id == 3) {
        precio_sugerido = producto.pv3 > 0 ? producto.pv3 : precio_sugerido
      }
      return parseFloat(precio_sugerido)
    },

    obtenerPrecioSugerido2(producto, tipo_cliente_id) {
      let precio_sugerido = producto.precio_sugerido
      if (tipo_cliente_id == 2) {
        precio_sugerido = producto.stock[0].pv2 > 0 ? producto.stock[0].pv2 : precio_sugerido
      } else if (tipo_cliente_id == 3) {
        precio_sugerido = producto.stock[0].pv3 > 0 ? producto.stock[0].pv3 : precio_sugerido
      }
      return parseFloat(precio_sugerido)
    }
  },

  watch: {
    clienteSelect(datos) {
      if (this.facturar == true) {
        // si es factura
      } else {
        this.nit = datos.ci_nit ?? ''
        this.razon_social = datos.nombre ?? ''
      }
    },

    productoSelecionado(newVal) {
      if (newVal != null && newVal.id) {
        this.fechas_vencimiento = []
        this.stockSucursales = []

        let precio_sugerido = this.obtenerPrecioSugerido(newVal.stock[0], this.clienteSelect.tipo_cliente_id)

        if (newVal.fechas_vencimiento.length > 1) {
          this.mostrarTablaFechasVencimiento = true
          newVal.fechas_vencimiento.forEach((producto) => {
            this.fechas_vencimiento.push({
              ...producto,
              fabrica_nombre: newVal.fabrica_nombre,
              nombre_producto: newVal.descripcion,
              ultimo_precio: precio_sugerido,
              cantidad_venta: 1,
              descuento_neto: 0,
              descuento_porcentaje: 0
            })
          })
        } else {
          this.mostrarTablaFechasVencimiento = false
          newVal.stock.forEach((producto) => {
            this.stockSucursales.push({
              ...producto,
              ultimo_precio: precio_sugerido,
              cantidad_venta: 1,
              descuento_neto: 0,
              descuento_porcentaje: 0,
              fecha_vence: producto.fecha_vence ?? null,
              lote: producto.lote ?? null
            })
            if (producto.id == this.stockSucursales[0].id) {
              this.agregarDetalleVenta(this.stockSucursales[0])
            }
          })
        }

        this.$nextTick(() => {
          this.productoSelecionado = null
          this.productosListadoFiltrado = []
        })
      }
    },
    codProdSelected(newVal) {
      if (newVal != null) {
        if (newVal.id) {
          //this.productosVentas.push(newVal);
          this.stockSucursales = []
          newVal.stock.forEach((sucursal) => {
            let precio_sugerido = sucursal.ultimo_precio == 0 ? newVal.precio_sugerido : sucursal.ultimo_precio
            this.stockSucursales.push({
              ...sucursal,
              ultimo_precio: parseFloat(precio_sugerido),
              cantidad_venta: 1,
              descuento_neto: 0,
              descuento_porcentaje: 0
            })
            // automaticamente selecciono la sucursal con el menor id y llamo a mi funcion agregarDetalleVenta
            if (sucursal.id == this.stockSucursales[0].id) {
              this.agregarDetalleVenta(this.stockSucursales[0])
            }
          })
        }
      }
    },
    total_venta() {
      if (this.tipo_pagoSelect == 1) {
        this.efectivo = this.total_venta
      } else {
        this.a_cuenta = 0
        this.efectivo = 0
      }
      if (this.metodo_pagoSelect == 1) {
        this.monto_pago = 0
      } else {
        this.monto_pago = this.total_venta
      }
    },
    a_cuenta() {
      if (this.a_cuenta > this.total_venta) {
        this.$toast.add({
          severity: 'info',
          summary: 'Venta',
          detail: 'El monto a cuenta no puede ser mayor al total de la venta',
          life: 60000
        })
        this.a_cuenta = 0
        return
      }
      this.efectivo = this.a_cuenta
    },
    monto_pago() {
      if (this.tipo_pagoSelect == 2) {
        this.efectivo = this.a_cuenta
      } else {
        this.efectivo = this.total_venta - this.monto_pago
      }
    },
    /* tipo_pagoSelect() {
      if (this.tipo_pagoSelect == 1) {
        this.a_cuenta = 0;
        this.monto_pago = 0;
        this.dias_credito = 0;
        this.efectivo = this.total_venta;
        this.a_credito_check = false;
      } else {
        this.dias_credito = 30;
        this.a_cuenta = 0;
        this.metodo_pagoSelect = 1;
        this.monto_pago = 0;
        this.efectivo = this.a_cuenta;
      }
    }, */
    metodo_pagoSelect() {
      if (this.metodo_pagoSelect == 1) {
        this.monto_pago = 0
        this.efectivo = this.total_venta - this.a_cuenta
        this.metodo_pago_check = false
        this.nro_tarjeta = null
      } else if (this.metodo_pagoSelect == 2 && this.a_credito_check) {
        this.monto_pago = 0
        this.efectivo = 0
      } else {
        this.efectivo = 0
        this.monto_pago = this.total_venta - this.efectivo
      }
    },
    metodo_pago_check() {
      if (this.metodo_pago_check) {
        this.metodo_pagoSelect = 6
        this.efectivo = 0
        this.monto_pago = this.total_venta - this.efectivo
      } else {
        this.metodo_pagoSelect = 1
        this.metodo_pago_check = false
        this.monto_pago = 0
        this.efectivo = this.total_venta - this.a_cuenta
        this.nro_tarjeta = ''
      }
    },
    a_credito_check() {
      if (this.a_credito_check) {
        this.tipo_pagoSelect = 2
        this.dias_credito = 30
        this.a_cuenta = null
        this.metodo_pagoSelect = 1
        this.monto_pago = 0
        this.efectivo = this.a_cuenta
      } else {
        this.tipo_pagoSelect = 1
        this.a_credito_check = false
        this.a_cuenta = null
        this.dias_credito = 0
        this.efectivo = this.total_venta
        this.monto_pago = 0
      }
    },
    aplica_descuento() {
      if (this.aplica_descuento) {
        // Solo calcular descuentos automáticos si está habilitado
        if (this.descuentos_configurables) {
          this.calcularDescuentosAplicables()
        }
        // Si no está habilitado, el usuario aplica descuento manual normalmente
      } else {
        this.desc_venta_porcentaje = 0
        this.descuento = 0
        this.descuentos_aplicables = []
        this.calcular_total_venta()
      }
    },
    facturar(nuevoValor, valorAnterior) {
      // Solo limpiar cuando se DESACTIVA facturar
      if (!nuevoValor && valorAnterior) {
        this.nit = ''
        this.razon_social = ''
        this.nitClienteSelect = null
      }
    },

    tipo_pagoSelect(nuevo, viejo) {
      if (this.aplica_descuento && this.descuentos_configurables && nuevo !== viejo) {
        this.calcularDescuentosAplicables()
      }
    },

    dias_credito(nuevo, viejo) {
      if (this.aplica_descuento && this.descuentos_configurables && this.tipo_pagoSelect === 2 && nuevo !== viejo) {
        this.calcularDescuentosAplicables()
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.p-invalid {
  color: red;
}

::v-deep(.editable-cells-table td.p-cell-editing) {
  padding-top: 0;
  padding-bottom: 0;
}

.outofstock {
  font-weight: 700;
  color: #000000;
  background-color: #747474;
  padding: 0 0.5em;
  border-radius: 0.5em;
}

.lowstock {
  font-weight: 700;
  color: #000000;
  background-color: #fbc02d;
  padding: 0 0.5em;
  border-radius: 0.5em;
}

.instock {
  font-weight: 700;
  color: #000000;
  background-color: #7bffae;
  padding: 0 0.5em;
  border-radius: 0.5em;
}

.p-fondo {
  background-color: #6abad0;
  border-radius: 0.5em;
  border: 1px solid #002236;
}

.precio {
  font-weight: 700;
  color: #000000;
  background-color: #7bffae;
  padding: 0 0.5em;
  border-radius: 0.5em;
}

//quiero que esta  clase no tenga el  fondo de plomo
.p-inputgroup-addon {
  background-color: #ffffff;
  font-weight: bold;
  color: #000000;
  border: none;
}

/* Estilo general para los botones */
.estiloBoton {
  background-color: #002236;
  /* Color oscuro para el botón seleccionado */
  color: #ffffff;
  border: none;
  border-radius: 0.5em;
  font-weight: bold;
  transition: background-color 0.3s, color 0.3s;
  /* Transición suave para el cambio de color */
}

/* Estilo para el botón no seleccionado */
.estiloBoton:not(.activo) {
  background-color: #d0d0d0;
  /* Color gris suave para el botón no seleccionado */
  color: #333333;
}

/* Estilo para el botón seleccionado */
.estiloBoton.activo {
  background-color: #004080;
  /* Color más claro o diferente para el botón seleccionado */
  color: #ffffff;
}

/* Hover para botones seleccionados y no seleccionados */
.estiloBoton:hover {
  background-color: #003366;
  /* Color ligeramente diferente para el hover en el botón seleccionado */
  color: #ffffff;
}

.estiloBoton:not(.activo):hover {
  background-color: #b0b0b0;
  /* Color ligeramente más oscuro para el hover en el botón no seleccionado */
  color: #333333;
}

.modal-facturacion {
  ::v-deep(.p-dialog-header) {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    color: white;
    padding: 1.5rem;

    .p-dialog-title {
      font-weight: bold;
      font-size: 1.2rem;
    }
  }

  ::v-deep(.p-dialog-content) {
    padding: 2rem;
  }
}

.loading-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 2rem 1rem;
}

.loading-info {
  font-size: 1rem;
  font-weight: 500;
  text-align: center;
  width: 100%;
}

.warning-box {
  background-color: #fff3cd;
  border: 1px solid #ffeeba;
  border-radius: 0.5rem;
  margin-top: 1rem;
}

.p-button-danger.p-button-sm {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 2px 8px rgba(220, 53, 69, 0.3);
  }
}

/* Clase para el número del NIT */
.nit-numero-destacado {
  font-size: 1.3rem;
  font-weight: 900;
  color: #2c3e50;
  display: inline-block;
  transition: all 0.2s ease-in-out;
  padding: 0 4px;
}

/* Efecto al pasar el cursor (Hover) */
.nit-numero-destacado:hover {
  transform: scale(1.4);
  color: #ffffff;
  background-color: #002236;
  text-shadow: 0 0 8px rgba(255, 255, 255, 0.7);
  cursor: default;
}

.tabla-header {
  display: flex;
  align-items: center;
  padding: 4px 6px;
  background: #002236;
  color: white;
  font-weight: 700;
  font-size: 0.75rem;
  letter-spacing: 0.3px;
  position: sticky;
  top: 0;
  z-index: 10;
}

.th {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 4px;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
}

.th:last-child {
  border-right: none;
}

.th-producto {
  flex: 1;
  justify-content: flex-start;
  min-width: 0;
}

.th-fabrica {
  width: 120px;
  flex-shrink: 0;
}

.th-caso {
  width: 100px;
  flex-shrink: 0;
}

.th-stock {
  width: 60px;
  flex-shrink: 0;
}

.th-precio {
  width: 80px;
  flex-shrink: 0;
}
/* ========== DESKTOP - COMPACTO ========== */
.tabla-fila {
  display: flex;
  align-items: center;
  padding: 0px 0px;
  border-bottom: 1px solid #e5e7eb;
  cursor: pointer;
  transition: all 0.2s ease;
  min-height: 0px;
  font-size: 1rem;
}

.tabla-fila:hover {
  background: linear-gradient(to right, #eff6ff 0%, #dbeafe 100%);
  transform: scale(1.02);
  box-shadow: 0 2px 6px rgba(59, 130, 246, 0.12);
  z-index: 5;
}

.tabla-fila.sin-stock {
  background-color: #fee2e2 !important;
  opacity: 0.7;
}

/* CELDAS */
.td {
  display: flex;
  align-items: center;
  padding: 0 4px;
  border-right: 1px solid #e5e7eb;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.td:last-child {
  border-right: none;
}

.td-producto {
  flex: 1;
  font-weight: 600;
  color: #1f2937;
  justify-content: flex-start;
  gap: 4px;
  min-width: 0;
}

.um-badge {
  color: #1e40af;
  font-weight: 700;
  background: #dbeafe;
  padding: 1px 5px;
  border-radius: 3px;
  font-size: 1rem;
  white-space: nowrap;
  flex-shrink: 0;
}

/* FÁBRICA - MÁS COMPACTO CON ELLIPSIS */
.td-fabrica {
  flex: 0 0 auto;
  max-width: 100px; /* Ajustable según necesites */
  font-weight: 600;
  color: #4b5563;
  font-size: 1rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.td-caso {
  width: 100px;
  background: #d1fae5;
  color: #065f46;
  font-weight: 600;
  padding: 2px 6px;
  border-radius: 3px;
  font-size: 0.68rem;
  justify-content: center;
  flex-shrink: 0;
}

.td-stock {
  width: 60px;
  font-weight: 700;
  justify-content: center;
  border-radius: 4px;
  font-size: 1rem;
  flex-shrink: 0;
}

.td-precio {
  width: 80px;
  color: #000000;
  font-weight: 700;
  font-size: 1rem;
  justify-content: center;
  flex-shrink: 0;
}

/* ========== MOBILE - ULTRA COMPACTO ========== */
@media (max-width: 768px) {
  .tabla-fila {
    display: grid !important;
    grid-template-columns: 1fr auto auto !important;
    grid-template-rows: auto auto !important;
    gap: 4px 4px !important; /* Reducido de 8px */
    padding: 6px 4px !important; /* Reducido de 10px */
    font-size: 0.95rem !important; /* Reducido */
  }

  /* LÍNEA 1: PRODUCTO */
  .td-producto {
    grid-column: 1 / 4 !important;
    grid-row: 1 !important;
    font-weight: 700 !important;
    white-space: normal !important;
    display: -webkit-box !important;
    -webkit-line-clamp: 2 !important;
    -webkit-box-orient: vertical !important;
    overflow: hidden !important;
    padding: 0 !important;
    border: none !important;
    font-size: 0.9rem !important; /* Reducido */
  }

  /* LÍNEA 2: LABORATORIO | STOCK | PRECIO */
  .td-fabrica {
    grid-column: 1 !important;
    grid-row: 2 !important;
    max-width: none !important;
    background: #e0e0e0 !important;
    padding: 3px 6px !important; /* Reducido de 4px 8px */
    border-radius: 3px !important;
    font-weight: 700 !important;
    border: none !important;
    font-size: 0.85rem !important; /* Reducido */
    white-space: nowrap !important;
    overflow: hidden !important;
    text-overflow: ellipsis !important;
  }

  .td-caso {
    display: none !important;
  }

  .td-stock {
    grid-column: 2 !important;
    grid-row: 2 !important;
    width: auto !important;
    padding: 3px 6px !important; /* Reducido de 4px 8px */
    border: none !important;
    font-size: 0.95rem !important;
  }

  .td-precio {
    grid-column: 3 !important;
    grid-row: 2 !important;
    width: auto !important;
    background: #f44336 !important;
    color: white !important;
    padding: 3px 8px !important; /* Reducido de 4px 10px */
    border-radius: 3px !important;
    border: none !important;
    font-size: 0.95rem !important;
  }

  .um-badge {
    font-size: 0.65rem !important; /* Reducido */
    padding: 1px 4px !important;
  }
}

@media (max-width: 480px) {
  .tabla-fila {
    padding: 5px 4px !important; /* Más compacto */
    gap: 3px 3px !important;
  }

  .td-producto {
    font-size: 0.85rem !important;
  }

  .td-fabrica {
    font-size: 0.8rem !important;
    padding: 2px 5px !important;
  }

  .td-stock,
  .td-precio {
    font-size: 0.9rem !important;
    padding: 2px 6px !important;
  }
}
</style>
